import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Account = {
  __typename?: 'Account';
  accessLevel?: Maybe<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  authProvider?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  eVChargerServiceRequest?: Maybe<EvChargerServiceRequest>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  googleId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  invitedByVendor?: Maybe<Vendor>;
  isAdmin: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  onboardingCompleted: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userType: Scalars['String']['output'];
  vendor?: Maybe<Vendor>;
};

export type AccountResponse = {
  __typename?: 'AccountResponse';
  account?: Maybe<Account>;
  errors?: Maybe<Array<FieldError>>;
};

export type AddTicketCommentInput = {
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<MessageAttachmentInput>>;
  body: Scalars['String']['input'];
  ticketId: Scalars['Int']['input'];
};

export type AdminSummary = {
  __typename?: 'AdminSummary';
  openTickets: Scalars['Int']['output'];
  pendingGoogleReviews: Scalars['Int']['output'];
  unverifiedVendors: Scalars['Int']['output'];
};

export type AdminUserPage = {
  __typename?: 'AdminUserPage';
  items: Array<AdminUserView>;
  total: Scalars['Int']['output'];
};

export type AdminUserResponse = {
  __typename?: 'AdminUserResponse';
  errors?: Maybe<Array<FieldError>>;
  user?: Maybe<AdminUserView>;
};

export type AdminUserView = {
  __typename?: 'AdminUserView';
  account: Account;
  id: Scalars['Int']['output'];
  isAdmin: Scalars['Boolean']['output'];
  portalVendorName?: Maybe<Scalars['String']['output']>;
  suspendedAt?: Maybe<Scalars['String']['output']>;
};

export enum AdminVendorFilter {
  All = 'ALL',
  Approved = 'APPROVED',
  NeedsReverification = 'NEEDS_REVERIFICATION',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  PendingGoogle = 'PENDING_GOOGLE',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED'
}

export type AdminVendorPage = {
  __typename?: 'AdminVendorPage';
  items: Array<AdminVendorView>;
  total: Scalars['Int']['output'];
};

export type AdminVendorResponse = {
  __typename?: 'AdminVendorResponse';
  errors?: Maybe<Array<FieldError>>;
  vendor?: Maybe<AdminVendorView>;
};

export type AdminVendorView = {
  __typename?: 'AdminVendorView';
  accountCount: Scalars['Int']['output'];
  googleLinkStatus: GoogleLinkReview;
  id: Scalars['Int']['output'];
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  reviewListing?: Maybe<GoogleListing>;
  suspendedAt?: Maybe<Scalars['String']['output']>;
  vendor: Vendor;
};

export type AnalyticsBreakdownRow = {
  __typename?: 'AnalyticsBreakdownRow';
  events: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  visitors: Scalars['Int']['output'];
};

export type AnalyticsBreakdowns = {
  __typename?: 'AnalyticsBreakdowns';
  browsers: Array<AnalyticsBreakdownRow>;
  cities: Array<AnalyticsBreakdownRow>;
  countries: Array<AnalyticsBreakdownRow>;
  devices: Array<AnalyticsBreakdownRow>;
  pages: Array<AnalyticsBreakdownRow>;
  referrers: Array<AnalyticsBreakdownRow>;
  regions: Array<AnalyticsBreakdownRow>;
};

export type AnalyticsFunnelStep = {
  __typename?: 'AnalyticsFunnelStep';
  index?: Maybe<Scalars['Int']['output']>;
  step: Scalars['String']['output'];
  visitors: Scalars['Int']['output'];
};

export type AnalyticsOverview = {
  __typename?: 'AnalyticsOverview';
  errors: Scalars['Int']['output'];
  estimatorStarts: Scalars['Int']['output'];
  estimatorSubmissions: Scalars['Int']['output'];
  pageviews: Scalars['Int']['output'];
  signups: Scalars['Int']['output'];
  uniqueVisitors: Scalars['Int']['output'];
};

export type AnalyticsTimeseriesPoint = {
  __typename?: 'AnalyticsTimeseriesPoint';
  date: Scalars['String']['output'];
  pageviews: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
};

export type Booking = {
  __typename?: 'Booking';
  allDay: Scalars['Boolean']['output'];
  attachments: Array<BookingAttachmentType>;
  attendees: Array<BookingAttendeeType>;
  createdAt: Scalars['String']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  createdByRole?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fromTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  meetingLink?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<EvChargerQuote>;
  quoteId?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  toTime: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  vendorId?: Maybe<Scalars['Int']['output']>;
  vendorNote?: Maybe<Scalars['String']['output']>;
};

export type BookingAttachmentInput = {
  name: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type BookingAttachmentType = {
  __typename?: 'BookingAttachmentType';
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type BookingAttendeeInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  proposedDate?: InputMaybe<Scalars['String']['input']>;
  proposedFrom?: InputMaybe<Scalars['String']['input']>;
  proposedTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type BookingAttendeeType = {
  __typename?: 'BookingAttendeeType';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  proposedDate?: Maybe<Scalars['String']['output']>;
  proposedFrom?: Maybe<Scalars['String']['output']>;
  proposedTo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BookingBusySlot = {
  __typename?: 'BookingBusySlot';
  allDay: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  fromTime: Scalars['String']['output'];
  toTime: Scalars['String']['output'];
};

export type BookingInput = {
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  attachments: Array<BookingAttachmentInput>;
  attendees: Array<BookingAttendeeInput>;
  date: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fromTime: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  toTime: Scalars['String']['input'];
  type: Scalars['String']['input'];
  vendorNote?: InputMaybe<Scalars['String']['input']>;
};

export type BookingResponse = {
  __typename?: 'BookingResponse';
  booking?: Maybe<Booking>;
  errors?: Maybe<Array<FieldError>>;
};

export type ChargerConfigData = {
  evseType: Array<TextBoxSelectionData>;
};

export type ClientPasswordResponse = {
  __typename?: 'ClientPasswordResponse';
  account?: Maybe<Account>;
  errors?: Maybe<Array<FieldError>>;
};

export type ConversationResponse = {
  __typename?: 'ConversationResponse';
  conversation?: Maybe<ConversationView>;
  errors?: Maybe<Array<FieldError>>;
};

export type ConversationView = {
  __typename?: 'ConversationView';
  archived: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lastMessageAt?: Maybe<Scalars['String']['output']>;
  lastMessageBody?: Maybe<Scalars['String']['output']>;
  otherPartyAvatarUrl?: Maybe<Scalars['String']['output']>;
  otherPartyName: Scalars['String']['output'];
  starred: Scalars['Boolean']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type CreateSupportTicketInput = {
  attachments?: InputMaybe<Array<MessageAttachmentInput>>;
  body: Scalars['String']['input'];
  category: TicketCategory;
  portalSlug?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type CustomDateInput = {
  availability: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  perDay?: InputMaybe<Array<PerDayHoursInput>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type CustomDateType = {
  __typename?: 'CustomDateType';
  availability: Scalars['String']['output'];
  date?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  perDay?: Maybe<Array<PerDayHoursType>>;
  startDate?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type DayHoursInput = {
  available: Scalars['Boolean']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type DayHoursType = {
  __typename?: 'DayHoursType';
  available: Scalars['Boolean']['output'];
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Ev = {
  __typename?: 'EV';
  cityEnergyConsumption?: Maybe<Scalars['Float']['output']>;
  cityFuelConsumptionLe?: Maybe<Scalars['Float']['output']>;
  co2Emissions?: Maybe<Scalars['Int']['output']>;
  co2Rating?: Maybe<Scalars['Int']['output']>;
  combinedEnergyConsumption?: Maybe<Scalars['Float']['output']>;
  combinedFuelConsumptionLe?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  fuelType?: Maybe<Scalars['String']['output']>;
  highwayEnergyConsumption?: Maybe<Scalars['Float']['output']>;
  highwayFuelConsumptionLe?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  modelYear: Scalars['Int']['output'];
  motor?: Maybe<Scalars['Int']['output']>;
  range?: Maybe<Scalars['Int']['output']>;
  rechargeTime?: Maybe<Scalars['Float']['output']>;
  smogRating?: Maybe<Scalars['Int']['output']>;
  transmission?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  vehicleClass?: Maybe<Scalars['String']['output']>;
};

export type EvChargerQuote = {
  __typename?: 'EVChargerQuote';
  addOns: Array<QuoteAddOn>;
  approvalRespondedAt?: Maybe<Scalars['String']['output']>;
  approvalStatus: QuoteApprovalStatus;
  archived?: Maybe<Scalars['Boolean']['output']>;
  assignedTo: Scalars['String']['output'];
  assumptions: Array<Scalars['String']['output']>;
  changeRequestNote?: Maybe<Scalars['String']['output']>;
  chargerCost: Scalars['Float']['output'];
  chargerModel: Scalars['String']['output'];
  chargerServiceRequest: EvChargerServiceRequest;
  createdAt: Scalars['String']['output'];
  distance: Scalars['String']['output'];
  estimateNumber: Scalars['String']['output'];
  evChargerService: EvChargerService;
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  inclusions: Array<Scalars['String']['output']>;
  installationCost: Scalars['Float']['output'];
  isExpired: Scalars['Boolean']['output'];
  notes: Array<Scalars['String']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  stage: Scalars['String']['output'];
  starred?: Maybe<Scalars['Boolean']['output']>;
  subtotal: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxLabel: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
  userAccepted: Scalars['Boolean']['output'];
  viewed?: Maybe<Scalars['Boolean']['output']>;
};

export type EvChargerQuoteInput = {
  addOnService?: InputMaybe<Scalars['String']['input']>;
  addOnServiceCost?: InputMaybe<Scalars['Float']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<Array<Scalars['String']['input']>>;
  chargerCost: Scalars['Float']['input'];
  chargerModel: Scalars['String']['input'];
  distance?: InputMaybe<Scalars['String']['input']>;
  evChargerServiceId: Scalars['Float']['input'];
  inclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  installationCost: Scalars['Float']['input'];
  notes?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  totalCost: Scalars['Float']['input'];
  userAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvChargerQuoteResponse = {
  __typename?: 'EVChargerQuoteResponse';
  errors?: Maybe<Array<FieldError>>;
  quote?: Maybe<EvChargerQuote>;
};

export type EvChargerService = {
  __typename?: 'EVChargerService';
  archivedAt?: Maybe<Scalars['String']['output']>;
  areaServiced?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  distanceKm?: Maybe<Scalars['Float']['output']>;
  evChargerServiceFields?: Maybe<Array<EvChargerServiceField>>;
  id: Scalars['Float']['output'];
  paymentTerms?: Maybe<Scalars['String']['output']>;
  quoteValidFor: Scalars['String']['output'];
  quotes?: Maybe<Array<EvChargerQuote>>;
  updatedAt: Scalars['String']['output'];
  vendor: Vendor;
};

export type EvChargerServiceField = {
  __typename?: 'EVChargerServiceField';
  createdAt: Scalars['String']['output'];
  customLabel?: Maybe<Scalars['String']['output']>;
  duplicates: Scalars['Boolean']['output'];
  evChargerService: EvChargerService;
  fieldLabel: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  fieldType: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  isChecked: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type EvChargerServiceInput = {
  data: EvServiceInstallationData;
};

export type EvChargerServiceRequest = {
  __typename?: 'EVChargerServiceRequest';
  account: Account;
  additionalInformation?: Maybe<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  chargerLocation: Scalars['String']['output'];
  chargerSetup: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  electricalPanelLocation: Scalars['String']['output'];
  electricalPanelPhotoURL: Scalars['String']['output'];
  elevator: Scalars['Boolean']['output'];
  hotTub: Scalars['Boolean']['output'];
  houseType: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  installationType: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mainBreakerPhotoURL: Scalars['String']['output'];
  mainServiceSize: Scalars['String']['output'];
  pool: Scalars['Boolean']['output'];
  purchaseType: Scalars['String']['output'];
  quotes: Array<EvChargerQuote>;
  updatedAt: Scalars['String']['output'];
  vehicleType?: Maybe<Scalars['String']['output']>;
  wireLength: Scalars['String']['output'];
};

export type EvChargerServiceRequestInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  chargerLocation: Scalars['String']['input'];
  chargerSetup: Scalars['String']['input'];
  electricalPanelLocation: Scalars['String']['input'];
  electricalPanelPhotoURL?: InputMaybe<Scalars['String']['input']>;
  elevator: Scalars['Boolean']['input'];
  hotTub: Scalars['Boolean']['input'];
  houseType: Scalars['String']['input'];
  installationType: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mainBreakerPhotoURL?: InputMaybe<Scalars['String']['input']>;
  mainServiceSize: Scalars['String']['input'];
  pool: Scalars['Boolean']['input'];
  purchaseType: Scalars['String']['input'];
  vehicleType?: InputMaybe<Scalars['String']['input']>;
  wireLength: Scalars['String']['input'];
};

export type EvChargerServiceRequestResponse = {
  __typename?: 'EVChargerServiceRequestResponse';
  errors?: Maybe<Array<FieldError>>;
  evChargerServiceRequest?: Maybe<EvChargerServiceRequest>;
};

export type EvChargerServiceResponse = {
  __typename?: 'EVChargerServiceResponse';
  errors?: Maybe<Array<FieldError>>;
  evChargerService?: Maybe<EvChargerService>;
};

/** Sort strategy for the top charger service list */
export enum EvChargerServiceSortBy {
  /** Sort by distance to user (not yet supported) */
  Distance = 'DISTANCE',
  /** Sort by cheapest base price (evseType + cableLength) */
  Price = 'PRICE',
  /** Sort by the vendor's live Google rating */
  Rating = 'RATING'
}

export type EmailPasswordInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type EmailVerificationResponse = {
  __typename?: 'EmailVerificationResponse';
  errors?: Maybe<Array<FieldError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EvServiceInstallationData = {
  chargerConfig: ChargerConfigData;
  installationConfig: InstallationConfigData;
  paymentAndAssumptionsConfigData: PaymentAndAssumptionsConfigData;
  serviceOfferingSetup: ServiceOfferingData;
};

export type ExpiringDocument = {
  __typename?: 'ExpiringDocument';
  daysLeft: Scalars['Int']['output'];
  expiryDate: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type FieldError = {
  __typename?: 'FieldError';
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FileUploadInput = {
  base64Data: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  folderPath?: InputMaybe<Scalars['String']['input']>;
};

export type FileUploadResponse = {
  __typename?: 'FileUploadResponse';
  error?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum GoogleLinkReview {
  Approved = 'APPROVED',
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED'
}

export type GoogleListing = {
  __typename?: 'GoogleListing';
  placeName?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount: Scalars['Int']['output'];
  reviewsUrl: Scalars['String']['output'];
};

export enum GoogleListingStatus {
  Linked = 'LINKED',
  NotLinked = 'NOT_LINKED',
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED',
  Retired = 'RETIRED',
  Unavailable = 'UNAVAILABLE'
}

export type Ice = {
  __typename?: 'ICE';
  cityFuelConsumption?: Maybe<Scalars['Float']['output']>;
  co2Emissions?: Maybe<Scalars['Int']['output']>;
  co2Rating?: Maybe<Scalars['Int']['output']>;
  combinedFuelConsumption?: Maybe<Scalars['Float']['output']>;
  combinedMPG?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  cylinders?: Maybe<Scalars['Int']['output']>;
  engineSize?: Maybe<Scalars['Float']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  highwayFuelConsumption?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  modelYear: Scalars['Int']['output'];
  smogRating?: Maybe<Scalars['Int']['output']>;
  transmission?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  vehicleClass?: Maybe<Scalars['String']['output']>;
};

export type InstallationConfigData = {
  addOnServices: Array<TextBoxSelectionData>;
  cableLength: Array<TextBoxSelectionData>;
  inclusions: Array<TextBoxSelectionData>;
};

export type MarketplaceHealth = {
  __typename?: 'MarketplaceHealth';
  bookings: Scalars['Int']['output'];
  newUsers: Scalars['Int']['output'];
  newVendors: Scalars['Int']['output'];
  quotesApproved: Scalars['Int']['output'];
  quotesSent: Scalars['Int']['output'];
  serviceRequests: Scalars['Int']['output'];
};

export type MessageAttachmentInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type MessageAttachmentType = {
  __typename?: 'MessageAttachmentType';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MessageView = {
  __typename?: 'MessageView';
  attachments: Array<MessageAttachmentType>;
  body: Scalars['String']['output'];
  conversationId: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  senderAvatarUrl?: Maybe<Scalars['String']['output']>;
  senderName: Scalars['String']['output'];
  senderSide: Scalars['String']['output'];
};

export type MessageableCounterpart = {
  __typename?: 'MessageableCounterpart';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  otherPartyId: Scalars['Int']['output'];
};

export type MessagesPage = {
  __typename?: 'MessagesPage';
  hasMore: Scalars['Boolean']['output'];
  messages: Array<MessageView>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptVendorAgreement: VendorResponse;
  addTicketComment: TicketCommentResponse;
  adminApproveReverification: AdminVendorResponse;
  adminApproveVendor: AdminVendorResponse;
  adminRejectVendor: AdminVendorResponse;
  adminReviewGoogleLink: AdminVendorResponse;
  adminSendExpiryReminder: AdminVendorResponse;
  adminSetAccountSuspended: AdminUserResponse;
  adminSetExpiryReminder: AdminVendorResponse;
  adminSetVendorPaused: AdminVendorResponse;
  adminSetVendorSuspended: AdminVendorResponse;
  cancelMeeting: BookingResponse;
  confirmMeeting: BookingResponse;
  createBooking: BookingResponse;
  createEVChargerService: EvChargerServiceResponse;
  createPrivateClientQuote: PrivateClientQuoteResponse;
  createServiceChargeQuote: EvChargerServiceRequestResponse;
  createSupportTicket: SupportTicketResponse;
  createVehicle: Vehicle;
  createVendor: VendorResponse;
  deleteAccount: Scalars['Boolean']['output'];
  deleteBooking: Scalars['Boolean']['output'];
  deleteEVChargerService: DeleteResponse;
  deleteQuote: Scalars['Boolean']['output'];
  deleteSupportTicket: Scalars['Boolean']['output'];
  deleteTicketComment: Scalars['Boolean']['output'];
  deleteVehicle: Scalars['Boolean']['output'];
  googleLogin: AccountResponse;
  login: AccountResponse;
  logout: Scalars['Boolean']['output'];
  markConversationRead?: Maybe<ConversationView>;
  markTicketRead?: Maybe<SupportTicketView>;
  registerAccount: AccountResponse;
  registerAccountWithVendor: AccountResponse;
  renewQuote?: Maybe<EvChargerQuote>;
  requestBooking: BookingResponse;
  requestPasswordReset: PasswordResetResponse;
  resendClientLink: ResendClientLinkResponse;
  resendPortalLink: Scalars['Boolean']['output'];
  resetPassword: PasswordResetResponse;
  respondToBooking: BookingResponse;
  respondToQuote: EvChargerQuoteResponse;
  resubmitVendorApplication: VendorResponse;
  reviseQuote: EvChargerQuoteResponse;
  sendEmailVerification: EmailVerificationResponse;
  sendMessage: SendMessageResponse;
  setClientPassword: ClientPasswordResponse;
  setConversationArchived?: Maybe<ConversationView>;
  setConversationStarred?: Maybe<ConversationView>;
  setOnboardingStep: VendorResponse;
  setPreferredLanguage: AccountResponse;
  setTicketStatus: SupportTicketResponse;
  setVendorAvailability: VendorAvailabilityResponse;
  startConversation: ConversationResponse;
  updateAccount: AccountResponse;
  updateBooking: BookingResponse;
  updateEVChargerService: EvChargerServiceResponse;
  updateMyQuote?: Maybe<EvChargerQuote>;
  updatePrivatePortal: PrivatePortalSettingsResponse;
  updateQuote?: Maybe<EvChargerQuote>;
  updateVehicle?: Maybe<Vehicle>;
  updateVendor: VendorResponse;
  uploadFile: FileUploadResponse;
  verifyEmailCode: EmailVerificationResponse;
};


export type MutationAddTicketCommentArgs = {
  options: AddTicketCommentInput;
};


export type MutationAdminApproveReverificationArgs = {
  vendorId: Scalars['Int']['input'];
};


export type MutationAdminApproveVendorArgs = {
  vendorId: Scalars['Int']['input'];
};


export type MutationAdminRejectVendorArgs = {
  reason: Scalars['String']['input'];
  vendorId: Scalars['Int']['input'];
};


export type MutationAdminReviewGoogleLinkArgs = {
  approve: Scalars['Boolean']['input'];
  vendorId: Scalars['Int']['input'];
};


export type MutationAdminSendExpiryReminderArgs = {
  vendorId: Scalars['Int']['input'];
};


export type MutationAdminSetAccountSuspendedArgs = {
  accountId: Scalars['Int']['input'];
  suspended: Scalars['Boolean']['input'];
};


export type MutationAdminSetExpiryReminderArgs = {
  enabled: Scalars['Boolean']['input'];
  vendorId: Scalars['Int']['input'];
};


export type MutationAdminSetVendorPausedArgs = {
  paused: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['Int']['input'];
};


export type MutationAdminSetVendorSuspendedArgs = {
  suspended: Scalars['Boolean']['input'];
  vendorId: Scalars['Int']['input'];
};


export type MutationCancelMeetingArgs = {
  bookingId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConfirmMeetingArgs = {
  bookingId: Scalars['Int']['input'];
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  newDate?: InputMaybe<Scalars['String']['input']>;
  newFrom?: InputMaybe<Scalars['String']['input']>;
  newTo?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBookingArgs = {
  input: BookingInput;
};


export type MutationCreateEvChargerServiceArgs = {
  options: EvChargerServiceInput;
};


export type MutationCreatePrivateClientQuoteArgs = {
  contactInput: PrivateClientContactInput;
  quoteInput: EvChargerQuoteInput;
  serviceRequestInput: EvChargerServiceRequestInput;
  slug: Scalars['String']['input'];
};


export type MutationCreateServiceChargeQuoteArgs = {
  quoteInput: EvChargerQuoteInput;
  serviceRequestInput: EvChargerServiceRequestInput;
};


export type MutationCreateSupportTicketArgs = {
  options: CreateSupportTicketInput;
};


export type MutationCreateVehicleArgs = {
  make: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateVendorArgs = {
  options: VendorInput;
};


export type MutationDeleteBookingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteEvChargerServiceArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeleteQuoteArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeleteSupportTicketArgs = {
  ticketId: Scalars['Int']['input'];
};


export type MutationDeleteTicketCommentArgs = {
  commentId: Scalars['Int']['input'];
};


export type MutationDeleteVehicleArgs = {
  id: Scalars['Float']['input'];
};


export type MutationGoogleLoginArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  options: EmailPasswordInput;
};


export type MutationMarkConversationReadArgs = {
  conversationId: Scalars['Int']['input'];
};


export type MutationMarkTicketReadArgs = {
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  ticketId: Scalars['Int']['input'];
};


export type MutationRegisterAccountArgs = {
  options: RegisterInput;
};


export type MutationRegisterAccountWithVendorArgs = {
  accountInput: RegisterInput;
  vendorInput: VendorInput;
};


export type MutationRenewQuoteArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRequestBookingArgs = {
  input: RequestBookingInput;
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendClientLinkArgs = {
  quoteId: Scalars['Int']['input'];
};


export type MutationResendPortalLinkArgs = {
  email: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationRespondToBookingArgs = {
  bookingId: Scalars['Int']['input'];
  proposedDate?: InputMaybe<Scalars['String']['input']>;
  proposedFrom?: InputMaybe<Scalars['String']['input']>;
  proposedTo?: InputMaybe<Scalars['String']['input']>;
  response: Scalars['String']['input'];
};


export type MutationRespondToQuoteArgs = {
  id: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  response: Scalars['String']['input'];
};


export type MutationReviseQuoteArgs = {
  id: Scalars['Int']['input'];
  input: ReviseQuoteInput;
};


export type MutationSendEmailVerificationArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendMessageArgs = {
  options: SendMessageInput;
};


export type MutationSetClientPasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationSetConversationArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  conversationId: Scalars['Int']['input'];
};


export type MutationSetConversationStarredArgs = {
  conversationId: Scalars['Int']['input'];
  starred: Scalars['Boolean']['input'];
};


export type MutationSetOnboardingStepArgs = {
  step: Scalars['String']['input'];
};


export type MutationSetPreferredLanguageArgs = {
  language: Scalars['String']['input'];
};


export type MutationSetTicketStatusArgs = {
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  status: TicketStatus;
  ticketId: Scalars['Int']['input'];
};


export type MutationSetVendorAvailabilityArgs = {
  input: SetVendorAvailabilityInput;
};


export type MutationStartConversationArgs = {
  otherPartyId: Scalars['Int']['input'];
};


export type MutationUpdateAccountArgs = {
  options: UpdateAccountInput;
};


export type MutationUpdateBookingArgs = {
  id: Scalars['Int']['input'];
  input: BookingInput;
};


export type MutationUpdateEvChargerServiceArgs = {
  id: Scalars['Float']['input'];
  options: EvChargerServiceInput;
};


export type MutationUpdateMyQuoteArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Float']['input'];
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdatePrivatePortalArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateQuoteArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  stage?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateVehicleArgs = {
  id: Scalars['Float']['input'];
  make?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateVendorArgs = {
  options: UpdateVendorInput;
};


export type MutationUploadFileArgs = {
  options: FileUploadInput;
};


export type MutationVerifyEmailCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type Phev = {
  __typename?: 'PHEV';
  cityFuelConsumption?: Maybe<Scalars['Float']['output']>;
  co2Emissions?: Maybe<Scalars['Int']['output']>;
  co2Rating?: Maybe<Scalars['Int']['output']>;
  combinedFuelConsumption?: Maybe<Scalars['Float']['output']>;
  combinedLe?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  cylinders?: Maybe<Scalars['Int']['output']>;
  engineSize?: Maybe<Scalars['Float']['output']>;
  fuelType1?: Maybe<Scalars['String']['output']>;
  fuelType2?: Maybe<Scalars['String']['output']>;
  highwayFuelConsumption?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  modelYear: Scalars['Int']['output'];
  motor?: Maybe<Scalars['Int']['output']>;
  range1?: Maybe<Scalars['Int']['output']>;
  range2?: Maybe<Scalars['Int']['output']>;
  rechargeTime?: Maybe<Scalars['Float']['output']>;
  smogRating?: Maybe<Scalars['Int']['output']>;
  transmission?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  vehicleClass?: Maybe<Scalars['String']['output']>;
};

export type PasswordResetResponse = {
  __typename?: 'PasswordResetResponse';
  errors?: Maybe<Array<FieldError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentAndAssumptionsConfigData = {
  assumptions: Array<TextBoxSelectionData>;
  paymentTerms: Scalars['String']['input'];
  paymentTypes: Array<TextBoxSelectionData>;
  quoteValidFor: Scalars['String']['input'];
};

export type PerDayHoursInput = {
  available: Scalars['Boolean']['input'];
  date: Scalars['String']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type PerDayHoursType = {
  __typename?: 'PerDayHoursType';
  available: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type PrivateClientContactInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type PrivateClientQuoteResponse = {
  __typename?: 'PrivateClientQuoteResponse';
  errors?: Maybe<Array<FieldError>>;
  quoteId?: Maybe<Scalars['Int']['output']>;
  signedIn: Scalars['Boolean']['output'];
};

export type PrivatePortalSettingsResponse = {
  __typename?: 'PrivatePortalSettingsResponse';
  errors?: Maybe<Array<FieldError>>;
  portalUrl?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Vendor>;
};

export type PrivatePortalVendor = {
  __typename?: 'PrivatePortalVendor';
  brandAbout?: Maybe<Scalars['String']['output']>;
  brandLogoURL?: Maybe<Scalars['String']['output']>;
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  portalLanguage?: Maybe<Scalars['String']['output']>;
  service?: Maybe<EvChargerService>;
  slug: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accounts: Array<Account>;
  adminExpiringVendors: Array<AdminVendorView>;
  adminSummary: AdminSummary;
  adminTickets: Array<SupportTicketView>;
  adminUsers: AdminUserPage;
  adminVendors: AdminVendorPage;
  analyticsBreakdowns: AnalyticsBreakdowns;
  analyticsFunnel: Array<AnalyticsFunnelStep>;
  analyticsOverview: AnalyticsOverview;
  analyticsTimeseries: Array<AnalyticsTimeseriesPoint>;
  evChargerQuote?: Maybe<EvChargerQuote>;
  evChargerServiceRequest?: Maybe<EvChargerServiceRequest>;
  getConversations: Array<ConversationView>;
  getEVChargerServiceList?: Maybe<Array<EvChargerService>>;
  getEVChargerServiceListByVendor?: Maybe<Array<EvChargerService>>;
  getEVChargerServiceRecommendations?: Maybe<Array<EvChargerService>>;
  getEVList?: Maybe<Array<Ev>>;
  getICEList?: Maybe<Array<Ice>>;
  getICEVehicle?: Maybe<Ice>;
  getLeadsByVendor: Array<EvChargerQuote>;
  getMessageableCounterparts: Array<MessageableCounterpart>;
  getMessages: MessagesPage;
  getPHEVList?: Maybe<Array<Phev>>;
  getQuotesByAccount: Array<EvChargerQuote>;
  marketplaceHealth: MarketplaceHealth;
  me?: Maybe<Account>;
  myInvitedBookings: Array<Booking>;
  myPortalSlug?: Maybe<Scalars['String']['output']>;
  myTickets: Array<SupportTicketView>;
  privatePortalVendor?: Maybe<PrivatePortalVendor>;
  supportTicket?: Maybe<SupportTicketView>;
  supportUnreadCount: Scalars['Int']['output'];
  ticketComments: Array<TicketCommentView>;
  vehicle?: Maybe<Vehicle>;
  vehicles: Array<Vehicle>;
  vendor?: Maybe<Vendor>;
  vendorAvailability?: Maybe<VendorAvailability>;
  vendorAvailabilityForQuote?: Maybe<QuoteVendorAvailability>;
  vendorBookings: Array<Booking>;
};


export type QueryAccountArgs = {
  id: Scalars['Float']['input'];
};


export type QueryAdminTicketsArgs = {
  status?: InputMaybe<TicketStatus>;
};


export type QueryAdminUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  suspendedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdminVendorsArgs = {
  filter?: InputMaybe<AdminVendorFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsBreakdownsArgs = {
  days?: Scalars['Int']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsFunnelArgs = {
  days?: Scalars['Int']['input'];
};


export type QueryAnalyticsOverviewArgs = {
  days?: Scalars['Int']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsTimeseriesArgs = {
  days?: Scalars['Int']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEvChargerQuoteArgs = {
  id: Scalars['Float']['input'];
};


export type QueryEvChargerServiceRequestArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetEvChargerServiceListArgs = {
  evseType?: InputMaybe<Scalars['String']['input']>;
  houseType?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<Scalars['String']['input']>;
  wireLength?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEvChargerServiceListByVendorArgs = {
  vendorId: Scalars['Float']['input'];
};


export type QueryGetEvChargerServiceRecommendationsArgs = {
  evseType?: InputMaybe<Scalars['String']['input']>;
  houseType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  sortBy?: InputMaybe<EvChargerServiceSortBy>;
  userLat?: InputMaybe<Scalars['Float']['input']>;
  userLng?: InputMaybe<Scalars['Float']['input']>;
  vehicleType?: InputMaybe<Scalars['String']['input']>;
  wireLength?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetIceVehicleArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetMessagesArgs = {
  beforeId?: InputMaybe<Scalars['Int']['input']>;
  conversationId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketplaceHealthArgs = {
  days?: Scalars['Int']['input'];
};


export type QueryPrivatePortalVendorArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySupportTicketArgs = {
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type QuerySupportUnreadCountArgs = {
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTicketCommentsArgs = {
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  ticketId: Scalars['Int']['input'];
};


export type QueryVehicleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVendorArgs = {
  id: Scalars['Float']['input'];
};


export type QueryVendorAvailabilityForQuoteArgs = {
  quoteId: Scalars['Int']['input'];
};

export type QuoteAddOn = {
  __typename?: 'QuoteAddOn';
  label: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type QuoteAddOnInput = {
  label: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export enum QuoteApprovalStatus {
  Approved = 'Approved',
  ChangesRequested = 'ChangesRequested',
  Pending = 'Pending'
}

export type QuoteCreatedEvent = {
  __typename?: 'QuoteCreatedEvent';
  quoteId: Scalars['Int']['output'];
};

export type QuoteVendorAvailability = {
  __typename?: 'QuoteVendorAvailability';
  availability?: Maybe<VendorAvailability>;
  availabilityConfigured: Scalars['Boolean']['output'];
  busySlots: Array<BookingBusySlot>;
};

export type RegisterInput = {
  accessLevel?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  onboardingCompleted?: Scalars['Boolean']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  placeId?: InputMaybe<Scalars['String']['input']>;
  profilePhotoUrl?: InputMaybe<Scalars['String']['input']>;
  userType?: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['Float']['input']>;
};

export type RequestBookingInput = {
  date: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fromTime: Scalars['String']['input'];
  quoteId: Scalars['Int']['input'];
  toTime: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ResendClientLinkResponse = {
  __typename?: 'ResendClientLinkResponse';
  errors?: Maybe<Array<FieldError>>;
  sent: Scalars['Boolean']['output'];
};

export type ReviseQuoteInput = {
  addOns?: InputMaybe<Array<QuoteAddOnInput>>;
  assumptions?: InputMaybe<Array<Scalars['String']['input']>>;
  chargerCost: Scalars['Float']['input'];
  chargerModel: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  inclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  installationCost: Scalars['Float']['input'];
  notes?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  vendorNote?: InputMaybe<Scalars['String']['input']>;
};

export type SendMessageInput = {
  attachments?: InputMaybe<Array<MessageAttachmentInput>>;
  body: Scalars['String']['input'];
  conversationId: Scalars['Int']['input'];
};

export type SendMessageResponse = {
  __typename?: 'SendMessageResponse';
  errors?: Maybe<Array<FieldError>>;
  message?: Maybe<MessageView>;
};

export type ServiceOfferingData = {
  areaServiced?: InputMaybe<Scalars['Int']['input']>;
  buildingServiced: Array<TextBoxSelectionData>;
  supportedEVSETypes: Array<TextBoxSelectionData>;
};

export type SetVendorAvailabilityInput = {
  allowSameDayBookings?: Scalars['Boolean']['input'];
  bookingHorizon: Scalars['String']['input'];
  bufferMinutes: Scalars['Int']['input'];
  customDates: Array<CustomDateInput>;
  weekly: WeeklyAvailabilityInput;
};

export type Subscription = {
  __typename?: 'Subscription';
  messageSent: MessageView;
  quoteCreated: QuoteCreatedEvent;
  quoteUpdated: QuoteCreatedEvent;
  supportTicketChanged: Scalars['Int']['output'];
};

export type SupportTicketResponse = {
  __typename?: 'SupportTicketResponse';
  errors?: Maybe<Array<FieldError>>;
  ticket?: Maybe<SupportTicketView>;
};

export type SupportTicketView = {
  __typename?: 'SupportTicketView';
  category: TicketCategory;
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastActivityAt: Scalars['String']['output'];
  lastCommentBody?: Maybe<Scalars['String']['output']>;
  portalVendorName?: Maybe<Scalars['String']['output']>;
  requesterAccountId: Scalars['Int']['output'];
  requesterBusinessName?: Maybe<Scalars['String']['output']>;
  requesterEmail: Scalars['String']['output'];
  requesterName: Scalars['String']['output'];
  requesterRole: Scalars['String']['output'];
  status: TicketStatus;
  subject: Scalars['String']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type TextBoxSelectionData = {
  duplicates?: Scalars['Boolean']['input'];
  enteredName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  isChecked?: Scalars['Boolean']['input'];
  optionName: Scalars['String']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

export enum TicketCategory {
  Account = 'ACCOUNT',
  Billing = 'BILLING',
  Bookings = 'BOOKINGS',
  Bug = 'BUG',
  GoogleListing = 'GOOGLE_LISTING',
  Other = 'OTHER',
  Quotes = 'QUOTES'
}

export type TicketCommentResponse = {
  __typename?: 'TicketCommentResponse';
  comment?: Maybe<TicketCommentView>;
  errors?: Maybe<Array<FieldError>>;
};

export type TicketCommentView = {
  __typename?: 'TicketCommentView';
  attachments: Array<MessageAttachmentType>;
  authorAvatarUrl?: Maybe<Scalars['String']['output']>;
  authorName: Scalars['String']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  fromAdmin: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  ticketId: Scalars['Int']['output'];
};

export enum TicketStatus {
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type UpdateAccountInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  profilePhotoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorInput = {
  brandAbout?: InputMaybe<Scalars['String']['input']>;
  brandGoogleReview?: InputMaybe<Scalars['String']['input']>;
  brandLogo?: InputMaybe<Scalars['String']['input']>;
  brandLogoURL?: InputMaybe<Scalars['String']['input']>;
  businessLicenseURL?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  businessWebsite?: InputMaybe<Scalars['String']['input']>;
  electricalLicenseExpiryDate?: InputMaybe<Scalars['String']['input']>;
  electricalLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  electricalLicenseURL?: InputMaybe<Scalars['String']['input']>;
  insuranceExpiryDate?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
  mailingSameAsBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  offeringEvInstallation?: InputMaybe<Scalars['String']['input']>;
  operatingAs?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<Scalars['String']['input']>;
  primaryContactEmail?: InputMaybe<Scalars['String']['input']>;
  primaryContactFirstName?: InputMaybe<Scalars['String']['input']>;
  primaryContactIsSignatory?: InputMaybe<Scalars['Boolean']['input']>;
  primaryContactLastName?: InputMaybe<Scalars['String']['input']>;
  primaryContactPhone?: InputMaybe<Scalars['String']['input']>;
  primaryContactPosition?: InputMaybe<Scalars['String']['input']>;
  proofOfInsuranceURL?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  publicEmail?: InputMaybe<Scalars['String']['input']>;
  publicPhone?: InputMaybe<Scalars['String']['input']>;
  signatoryEmail?: InputMaybe<Scalars['String']['input']>;
  signatoryFirstName?: InputMaybe<Scalars['String']['input']>;
  signatoryLastName?: InputMaybe<Scalars['String']['input']>;
  signatoryPhone?: InputMaybe<Scalars['String']['input']>;
  signatoryPosition?: InputMaybe<Scalars['String']['input']>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  createdAt: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  make: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type Vendor = {
  __typename?: 'Vendor';
  accounts: Array<Account>;
  address: Scalars['String']['output'];
  agreementAcceptedAt?: Maybe<Scalars['String']['output']>;
  agreementVersion?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<VendorAvailability>;
  availabilityConfigured: Scalars['Boolean']['output'];
  bookings?: Maybe<Array<Booking>>;
  brandAbout?: Maybe<Scalars['String']['output']>;
  brandGoogleReview?: Maybe<Scalars['String']['output']>;
  brandLogoURL?: Maybe<Scalars['String']['output']>;
  businessLicenseURL: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  businessNumber: Scalars['String']['output'];
  businessWebsite?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  electricalLicenseExpiryDate?: Maybe<Scalars['String']['output']>;
  electricalLicenseNumber?: Maybe<Scalars['String']['output']>;
  electricalLicenseURL?: Maybe<Scalars['String']['output']>;
  evChargerServices?: Maybe<Array<EvChargerService>>;
  expiringDocuments: Array<ExpiringDocument>;
  expiryReminderEnabled: Scalars['Boolean']['output'];
  googleListing?: Maybe<GoogleListing>;
  googleListingStatus: GoogleListingStatus;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  insuranceExpiryDate?: Maybe<Scalars['String']['output']>;
  insuranceReminderSentAt?: Maybe<Scalars['String']['output']>;
  isVerified: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  licenseReminderSentAt?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mailingAddress?: Maybe<Scalars['String']['output']>;
  mailingSameAsBusiness: Scalars['Boolean']['output'];
  notificationEmail?: Maybe<Scalars['String']['output']>;
  offeringEvInstallation: Scalars['String']['output'];
  onboardingStep?: Maybe<Scalars['String']['output']>;
  operatingAs?: Maybe<Scalars['String']['output']>;
  organizationType: Scalars['String']['output'];
  pauseReason?: Maybe<Scalars['String']['output']>;
  pausedAt?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
  portalLanguage?: Maybe<Scalars['String']['output']>;
  primaryContactEmail: Scalars['String']['output'];
  primaryContactFirstName: Scalars['String']['output'];
  primaryContactIsSignatory: Scalars['Boolean']['output'];
  primaryContactLastName: Scalars['String']['output'];
  primaryContactPhone: Scalars['String']['output'];
  primaryContactPosition: Scalars['String']['output'];
  privatePortalEnabled: Scalars['Boolean']['output'];
  privatePortalService?: Maybe<EvChargerService>;
  proofOfInsuranceURL: Scalars['String']['output'];
  province: Scalars['String']['output'];
  publicEmail?: Maybe<Scalars['String']['output']>;
  publicPhone?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  reverificationReasons: Array<Scalars['String']['output']>;
  reverificationRequestedAt?: Maybe<Scalars['String']['output']>;
  signatoryEmail?: Maybe<Scalars['String']['output']>;
  signatoryFirstName?: Maybe<Scalars['String']['output']>;
  signatoryLastName?: Maybe<Scalars['String']['output']>;
  signatoryPhone?: Maybe<Scalars['String']['output']>;
  signatoryPosition?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  termsAcceptedAt?: Maybe<Scalars['String']['output']>;
  termsName?: Maybe<Scalars['String']['output']>;
  termsVersion?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  verificationStatus: VendorVerification;
};

export type VendorAvailability = {
  __typename?: 'VendorAvailability';
  allowSameDayBookings: Scalars['Boolean']['output'];
  bookingHorizon: Scalars['String']['output'];
  bufferMinutes: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  customDates: Array<CustomDateType>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  weekly: WeeklyAvailabilityType;
};

export type VendorAvailabilityResponse = {
  __typename?: 'VendorAvailabilityResponse';
  availability?: Maybe<VendorAvailability>;
  errors?: Maybe<Array<FieldError>>;
};

export type VendorInput = {
  businessLicenseURL: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  declarationAccepted: Scalars['Boolean']['input'];
  electricalLicenseExpiryDate?: InputMaybe<Scalars['String']['input']>;
  electricalLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  electricalLicenseURL?: InputMaybe<Scalars['String']['input']>;
  insuranceExpiryDate: Scalars['String']['input'];
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
  mailingSameAsBusiness?: Scalars['Boolean']['input'];
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  offeringEvInstallation: Scalars['String']['input'];
  operatingAs?: InputMaybe<Scalars['String']['input']>;
  organizationType: Scalars['String']['input'];
  primaryContactEmail: Scalars['String']['input'];
  primaryContactFirstName: Scalars['String']['input'];
  primaryContactIsSignatory?: Scalars['Boolean']['input'];
  primaryContactLastName: Scalars['String']['input'];
  primaryContactPhone: Scalars['String']['input'];
  primaryContactPosition: Scalars['String']['input'];
  proofOfInsuranceURL: Scalars['String']['input'];
  province: Scalars['String']['input'];
  signatoryEmail?: InputMaybe<Scalars['String']['input']>;
  signatoryFirstName?: InputMaybe<Scalars['String']['input']>;
  signatoryLastName?: InputMaybe<Scalars['String']['input']>;
  signatoryPhone?: InputMaybe<Scalars['String']['input']>;
  signatoryPosition?: InputMaybe<Scalars['String']['input']>;
  termsAccepted: Scalars['Boolean']['input'];
};

export type VendorResponse = {
  __typename?: 'VendorResponse';
  errors?: Maybe<Array<FieldError>>;
  vendor?: Maybe<Vendor>;
  warnings?: Maybe<Array<FieldError>>;
};

export enum VendorVerification {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type WeeklyAvailabilityInput = {
  fri: DayHoursInput;
  mon: DayHoursInput;
  sat: DayHoursInput;
  sun: DayHoursInput;
  thu: DayHoursInput;
  tue: DayHoursInput;
  wed: DayHoursInput;
};

export type WeeklyAvailabilityType = {
  __typename?: 'WeeklyAvailabilityType';
  fri: DayHoursType;
  mon: DayHoursType;
  sat: DayHoursType;
  sun: DayHoursType;
  thu: DayHoursType;
  tue: DayHoursType;
  wed: DayHoursType;
};

export type AccountFragment = { __typename?: 'Account', id: number, email: string, firstName: string, lastName: string, userType: string, googleId?: string | null, authProvider?: string | null, phoneNumber: string, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, profilePhotoUrl?: string | null, jobTitle?: string | null, accessLevel?: string | null, onboardingCompleted: boolean, preferredLanguage?: string | null, isAdmin: boolean, createdAt: string, updatedAt: string, vendor?: { __typename?: 'Vendor', id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } | null };

export type AdminUserFragment = { __typename?: 'AdminUserView', id: number, suspendedAt?: string | null, portalVendorName?: string | null, isAdmin: boolean, account: { __typename?: 'Account', id: number, email: string, firstName: string, lastName: string, phoneNumber: string, address: string, profilePhotoUrl?: string | null, authProvider?: string | null, createdAt: string } };

export type AdminVendorFragment = { __typename?: 'AdminVendorView', id: number, googleLinkStatus: GoogleLinkReview, suspendedAt?: string | null, ownerName?: string | null, ownerEmail?: string | null, accountCount: number, reviewListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null, vendor: { __typename?: 'Vendor', phoneNumber: string, id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } };

export type AnalyticsBreakdownRowFragment = { __typename?: 'AnalyticsBreakdownRow', label: string, visitors: number, events: number };

export type BookingFragment = { __typename?: 'Booking', id: number, vendorId?: number | null, title: string, type: string, date: string, fromTime: string, toTime: string, allDay: boolean, location?: string | null, description?: string | null, status: string, meetingLink?: string | null, vendorNote?: string | null, createdByName?: string | null, createdByRole?: string | null, createdAt: string, attendees: Array<{ __typename?: 'BookingAttendeeType', email: string, name?: string | null, optional?: boolean | null, status?: string | null, proposedDate?: string | null, proposedFrom?: string | null, proposedTo?: string | null }>, attachments: Array<{ __typename?: 'BookingAttachmentType', name: string, url?: string | null }>, quote?: { __typename?: 'EVChargerQuote', id: number, estimateNumber: string, totalCost: number, chargerModel: string, stage: string } | null };

export type ConversationFragment = { __typename?: 'ConversationView', id: number, otherPartyName: string, otherPartyAvatarUrl?: string | null, lastMessageBody?: string | null, lastMessageAt?: string | null, unreadCount: number, starred: boolean, archived: boolean };

export type FileUploadFragment = { __typename?: 'FileUploadResponse', url?: string | null, error?: string | null };

export type GoogleListingFragment = { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string };

export type MessageFragment = { __typename?: 'MessageView', id: number, conversationId: number, senderSide: string, senderName: string, senderAvatarUrl?: string | null, body: string, createdAt: string, attachments: Array<{ __typename?: 'MessageAttachmentType', name: string, url: string }> };

export type RegularErrorFragment = { __typename?: 'FieldError', field?: string | null, message?: string | null };

export type SupportTicketFragment = { __typename?: 'SupportTicketView', id: number, subject: string, category: TicketCategory, status: TicketStatus, createdAt: string, lastActivityAt: string, unreadCount: number, lastCommentBody?: string | null, requesterAccountId: number, requesterName: string, requesterEmail: string, requesterRole: string, requesterBusinessName?: string | null, portalVendorName?: string | null };

export type TicketCommentFragment = { __typename?: 'TicketCommentView', id: number, ticketId: number, fromAdmin: boolean, authorName: string, authorAvatarUrl?: string | null, body: string, createdAt: string, attachments: Array<{ __typename?: 'MessageAttachmentType', name: string, url: string }> };

export type VendorFragment = { __typename?: 'Vendor', id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null };

export type VendorAvailabilityFragment = { __typename?: 'VendorAvailability', id: number, bufferMinutes: number, bookingHorizon: string, allowSameDayBookings: boolean, weekly: { __typename?: 'WeeklyAvailabilityType', mon: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, tue: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, wed: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, thu: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, fri: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, sat: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, sun: { __typename?: 'DayHoursType', available: boolean, from: string, to: string } }, customDates: Array<{ __typename?: 'CustomDateType', id: string, mode: string, date?: string | null, startDate?: string | null, endDate?: string | null, availability: string, from?: string | null, to?: string | null, note?: string | null, perDay?: Array<{ __typename?: 'PerDayHoursType', date: string, available: boolean, from: string, to: string }> | null }> };

export type AddTicketCommentMutationVariables = Exact<{
  options: AddTicketCommentInput;
}>;


export type AddTicketCommentMutation = { __typename?: 'Mutation', addTicketComment: { __typename?: 'TicketCommentResponse', comment?: { __typename?: 'TicketCommentView', id: number, ticketId: number, fromAdmin: boolean, authorName: string, authorAvatarUrl?: string | null, body: string, createdAt: string, attachments: Array<{ __typename?: 'MessageAttachmentType', name: string, url: string }> } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type AdminApproveReverificationMutationVariables = Exact<{
  vendorId: Scalars['Int']['input'];
}>;


export type AdminApproveReverificationMutation = { __typename?: 'Mutation', adminApproveReverification: { __typename?: 'AdminVendorResponse', vendor?: { __typename?: 'AdminVendorView', id: number, googleLinkStatus: GoogleLinkReview, suspendedAt?: string | null, ownerName?: string | null, ownerEmail?: string | null, accountCount: number, reviewListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null, vendor: { __typename?: 'Vendor', phoneNumber: string, id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type AdminApproveVendorMutationVariables = Exact<{
  vendorId: Scalars['Int']['input'];
}>;


export type AdminApproveVendorMutation = { __typename?: 'Mutation', adminApproveVendor: { __typename?: 'AdminVendorResponse', vendor?: { __typename?: 'AdminVendorView', id: number, googleLinkStatus: GoogleLinkReview, suspendedAt?: string | null, ownerName?: string | null, ownerEmail?: string | null, accountCount: number, reviewListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null, vendor: { __typename?: 'Vendor', phoneNumber: string, id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type AdminSendExpiryReminderMutationVariables = Exact<{
  vendorId: Scalars['Int']['input'];
}>;


export type AdminSendExpiryReminderMutation = { __typename?: 'Mutation', adminSendExpiryReminder: { __typename?: 'AdminVendorResponse', vendor?: { __typename?: 'AdminVendorView', id: number, googleLinkStatus: GoogleLinkReview, suspendedAt?: string | null, ownerName?: string | null, ownerEmail?: string | null, accountCount: number, reviewListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null, vendor: { __typename?: 'Vendor', phoneNumber: string, id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type AdminSetExpiryReminderMutationVariables = Exact<{
  vendorId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type AdminSetExpiryReminderMutation = { __typename?: 'Mutation', adminSetExpiryReminder: { __typename?: 'AdminVendorResponse', vendor?: { __typename?: 'AdminVendorView', id: number, googleLinkStatus: GoogleLinkReview, suspendedAt?: string | null, ownerName?: string | null, ownerEmail?: string | null, accountCount: number, reviewListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null, vendor: { __typename?: 'Vendor', phoneNumber: string, id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type AdminRejectVendorMutationVariables = Exact<{
  vendorId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
}>;


export type AdminRejectVendorMutation = { __typename?: 'Mutation', adminRejectVendor: { __typename?: 'AdminVendorResponse', vendor?: { __typename?: 'AdminVendorView', id: number, googleLinkStatus: GoogleLinkReview, suspendedAt?: string | null, ownerName?: string | null, ownerEmail?: string | null, accountCount: number, reviewListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null, vendor: { __typename?: 'Vendor', phoneNumber: string, id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type AdminReviewGoogleLinkMutationVariables = Exact<{
  vendorId: Scalars['Int']['input'];
  approve: Scalars['Boolean']['input'];
}>;


export type AdminReviewGoogleLinkMutation = { __typename?: 'Mutation', adminReviewGoogleLink: { __typename?: 'AdminVendorResponse', vendor?: { __typename?: 'AdminVendorView', id: number, googleLinkStatus: GoogleLinkReview, suspendedAt?: string | null, ownerName?: string | null, ownerEmail?: string | null, accountCount: number, reviewListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null, vendor: { __typename?: 'Vendor', phoneNumber: string, id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type AdminSetAccountSuspendedMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  suspended: Scalars['Boolean']['input'];
}>;


export type AdminSetAccountSuspendedMutation = { __typename?: 'Mutation', adminSetAccountSuspended: { __typename?: 'AdminUserResponse', user?: { __typename?: 'AdminUserView', id: number, suspendedAt?: string | null, portalVendorName?: string | null, isAdmin: boolean, account: { __typename?: 'Account', id: number, email: string, firstName: string, lastName: string, phoneNumber: string, address: string, profilePhotoUrl?: string | null, authProvider?: string | null, createdAt: string } } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type AdminSetVendorPausedMutationVariables = Exact<{
  vendorId: Scalars['Int']['input'];
  paused: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminSetVendorPausedMutation = { __typename?: 'Mutation', adminSetVendorPaused: { __typename?: 'AdminVendorResponse', vendor?: { __typename?: 'AdminVendorView', id: number, googleLinkStatus: GoogleLinkReview, suspendedAt?: string | null, ownerName?: string | null, ownerEmail?: string | null, accountCount: number, reviewListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null, vendor: { __typename?: 'Vendor', phoneNumber: string, id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type AdminSetVendorSuspendedMutationVariables = Exact<{
  vendorId: Scalars['Int']['input'];
  suspended: Scalars['Boolean']['input'];
}>;


export type AdminSetVendorSuspendedMutation = { __typename?: 'Mutation', adminSetVendorSuspended: { __typename?: 'AdminVendorResponse', vendor?: { __typename?: 'AdminVendorView', id: number, googleLinkStatus: GoogleLinkReview, suspendedAt?: string | null, ownerName?: string | null, ownerEmail?: string | null, accountCount: number, reviewListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null, vendor: { __typename?: 'Vendor', phoneNumber: string, id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type CancelMeetingMutationVariables = Exact<{
  bookingId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelMeetingMutation = { __typename?: 'Mutation', cancelMeeting: { __typename?: 'BookingResponse', booking?: { __typename?: 'Booking', id: number, vendorId?: number | null, title: string, type: string, date: string, fromTime: string, toTime: string, allDay: boolean, location?: string | null, description?: string | null, status: string, meetingLink?: string | null, vendorNote?: string | null, createdByName?: string | null, createdByRole?: string | null, createdAt: string, attendees: Array<{ __typename?: 'BookingAttendeeType', email: string, name?: string | null, optional?: boolean | null, status?: string | null, proposedDate?: string | null, proposedFrom?: string | null, proposedTo?: string | null }>, attachments: Array<{ __typename?: 'BookingAttachmentType', name: string, url?: string | null }>, quote?: { __typename?: 'EVChargerQuote', id: number, estimateNumber: string, totalCost: number, chargerModel: string, stage: string } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type ConfirmMeetingMutationVariables = Exact<{
  bookingId: Scalars['Int']['input'];
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  newDate?: InputMaybe<Scalars['String']['input']>;
  newFrom?: InputMaybe<Scalars['String']['input']>;
  newTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmMeetingMutation = { __typename?: 'Mutation', confirmMeeting: { __typename?: 'BookingResponse', booking?: { __typename?: 'Booking', id: number, vendorId?: number | null, title: string, type: string, date: string, fromTime: string, toTime: string, allDay: boolean, location?: string | null, description?: string | null, status: string, meetingLink?: string | null, vendorNote?: string | null, createdByName?: string | null, createdByRole?: string | null, createdAt: string, attendees: Array<{ __typename?: 'BookingAttendeeType', email: string, name?: string | null, optional?: boolean | null, status?: string | null, proposedDate?: string | null, proposedFrom?: string | null, proposedTo?: string | null }>, attachments: Array<{ __typename?: 'BookingAttachmentType', name: string, url?: string | null }>, quote?: { __typename?: 'EVChargerQuote', id: number, estimateNumber: string, totalCost: number, chargerModel: string, stage: string } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type CreateBookingMutationVariables = Exact<{
  input: BookingInput;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking: { __typename?: 'BookingResponse', booking?: { __typename?: 'Booking', id: number, vendorId?: number | null, title: string, type: string, date: string, fromTime: string, toTime: string, allDay: boolean, location?: string | null, description?: string | null, status: string, meetingLink?: string | null, vendorNote?: string | null, createdByName?: string | null, createdByRole?: string | null, createdAt: string, attendees: Array<{ __typename?: 'BookingAttendeeType', email: string, name?: string | null, optional?: boolean | null, status?: string | null, proposedDate?: string | null, proposedFrom?: string | null, proposedTo?: string | null }>, attachments: Array<{ __typename?: 'BookingAttachmentType', name: string, url?: string | null }>, quote?: { __typename?: 'EVChargerQuote', id: number, estimateNumber: string, totalCost: number, chargerModel: string, stage: string } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type CreateEvChargerServiceMutationVariables = Exact<{
  options: EvChargerServiceInput;
}>;


export type CreateEvChargerServiceMutation = { __typename?: 'Mutation', createEVChargerService: { __typename?: 'EVChargerServiceResponse', evChargerService?: { __typename?: 'EVChargerService', id: number, vendor: { __typename?: 'Vendor', id: number, businessName: string } } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type CreateServiceChargeQuoteMutationVariables = Exact<{
  serviceRequestInput: EvChargerServiceRequestInput;
  quoteInput: EvChargerQuoteInput;
}>;


export type CreateServiceChargeQuoteMutation = { __typename?: 'Mutation', createServiceChargeQuote: { __typename?: 'EVChargerServiceRequestResponse', evChargerServiceRequest?: { __typename?: 'EVChargerServiceRequest', id: number, quotes: Array<{ __typename?: 'EVChargerQuote', id: number, estimateNumber: string, chargerModel: string, subtotal: number, taxRate: number, taxAmount: number, taxLabel: string, totalCost: number }> } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type CreateSupportTicketMutationVariables = Exact<{
  options: CreateSupportTicketInput;
}>;


export type CreateSupportTicketMutation = { __typename?: 'Mutation', createSupportTicket: { __typename?: 'SupportTicketResponse', ticket?: { __typename?: 'SupportTicketView', id: number, subject: string, category: TicketCategory, status: TicketStatus, createdAt: string, lastActivityAt: string, unreadCount: number, lastCommentBody?: string | null, requesterAccountId: number, requesterName: string, requesterEmail: string, requesterRole: string, requesterBusinessName?: string | null, portalVendorName?: string | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: boolean };

export type DeleteBookingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteBookingMutation = { __typename?: 'Mutation', deleteBooking: boolean };

export type DeleteEvChargerServiceMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteEvChargerServiceMutation = { __typename?: 'Mutation', deleteEVChargerService: { __typename?: 'DeleteResponse', success: boolean, message?: string | null } };

export type DeleteQuoteMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteQuoteMutation = { __typename?: 'Mutation', deleteQuote: boolean };

export type DeleteSupportTicketMutationVariables = Exact<{
  ticketId: Scalars['Int']['input'];
}>;


export type DeleteSupportTicketMutation = { __typename?: 'Mutation', deleteSupportTicket: boolean };

export type DeleteTicketCommentMutationVariables = Exact<{
  commentId: Scalars['Int']['input'];
}>;


export type DeleteTicketCommentMutation = { __typename?: 'Mutation', deleteTicketComment: boolean };

export type GoogleLoginMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type GoogleLoginMutation = { __typename?: 'Mutation', googleLogin: { __typename?: 'AccountResponse', account?: { __typename?: 'Account', id: number, email: string, firstName: string, lastName: string, userType: string, googleId?: string | null, authProvider?: string | null, phoneNumber: string, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, profilePhotoUrl?: string | null, jobTitle?: string | null, accessLevel?: string | null, onboardingCompleted: boolean, preferredLanguage?: string | null, isAdmin: boolean, createdAt: string, updatedAt: string, vendor?: { __typename?: 'Vendor', id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type LoginMutationVariables = Exact<{
  options: EmailPasswordInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AccountResponse', account?: { __typename?: 'Account', id: number, email: string, firstName: string, lastName: string, userType: string, googleId?: string | null, authProvider?: string | null, phoneNumber: string, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, profilePhotoUrl?: string | null, jobTitle?: string | null, accessLevel?: string | null, onboardingCompleted: boolean, preferredLanguage?: string | null, isAdmin: boolean, createdAt: string, updatedAt: string, vendor?: { __typename?: 'Vendor', id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type MarkConversationReadMutationVariables = Exact<{
  conversationId: Scalars['Int']['input'];
}>;


export type MarkConversationReadMutation = { __typename?: 'Mutation', markConversationRead?: { __typename?: 'ConversationView', id: number, otherPartyName: string, otherPartyAvatarUrl?: string | null, lastMessageBody?: string | null, lastMessageAt?: string | null, unreadCount: number, starred: boolean, archived: boolean } | null };

export type MarkTicketReadMutationVariables = Exact<{
  ticketId: Scalars['Int']['input'];
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarkTicketReadMutation = { __typename?: 'Mutation', markTicketRead?: { __typename?: 'SupportTicketView', id: number, subject: string, category: TicketCategory, status: TicketStatus, createdAt: string, lastActivityAt: string, unreadCount: number, lastCommentBody?: string | null, requesterAccountId: number, requesterName: string, requesterEmail: string, requesterRole: string, requesterBusinessName?: string | null, portalVendorName?: string | null } | null };

export type AcceptVendorAgreementMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptVendorAgreementMutation = { __typename?: 'Mutation', acceptVendorAgreement: { __typename?: 'VendorResponse', vendor?: { __typename?: 'Vendor', id: number, agreementAcceptedAt?: string | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type SetOnboardingStepMutationVariables = Exact<{
  step: Scalars['String']['input'];
}>;


export type SetOnboardingStepMutation = { __typename?: 'Mutation', setOnboardingStep: { __typename?: 'VendorResponse', vendor?: { __typename?: 'Vendor', id: number, onboardingStep?: string | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: { __typename?: 'PasswordResetResponse', success?: boolean | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'PasswordResetResponse', success?: boolean | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type RegisterAccountMutationVariables = Exact<{
  options: RegisterInput;
}>;


export type RegisterAccountMutation = { __typename?: 'Mutation', registerAccount: { __typename?: 'AccountResponse', account?: { __typename?: 'Account', id: number, email: string, firstName: string, lastName: string, userType: string, googleId?: string | null, authProvider?: string | null, phoneNumber: string, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, profilePhotoUrl?: string | null, jobTitle?: string | null, accessLevel?: string | null, onboardingCompleted: boolean, preferredLanguage?: string | null, isAdmin: boolean, createdAt: string, updatedAt: string, vendor?: { __typename?: 'Vendor', id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type RegisterAccountWithVendorMutationVariables = Exact<{
  accountInput: RegisterInput;
  vendorInput: VendorInput;
}>;


export type RegisterAccountWithVendorMutation = { __typename?: 'Mutation', registerAccountWithVendor: { __typename?: 'AccountResponse', account?: { __typename?: 'Account', id: number, email: string, firstName: string, lastName: string, userType: string, googleId?: string | null, authProvider?: string | null, phoneNumber: string, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, profilePhotoUrl?: string | null, jobTitle?: string | null, accessLevel?: string | null, onboardingCompleted: boolean, preferredLanguage?: string | null, isAdmin: boolean, createdAt: string, updatedAt: string, vendor?: { __typename?: 'Vendor', id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type RenewQuoteMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type RenewQuoteMutation = { __typename?: 'Mutation', renewQuote?: { __typename?: 'EVChargerQuote', id: number, expiresAt?: string | null, isExpired: boolean } | null };

export type RequestBookingMutationVariables = Exact<{
  input: RequestBookingInput;
}>;


export type RequestBookingMutation = { __typename?: 'Mutation', requestBooking: { __typename?: 'BookingResponse', booking?: { __typename?: 'Booking', id: number, vendorId?: number | null, title: string, type: string, date: string, fromTime: string, toTime: string, allDay: boolean, location?: string | null, description?: string | null, status: string, meetingLink?: string | null, vendorNote?: string | null, createdByName?: string | null, createdByRole?: string | null, createdAt: string, attendees: Array<{ __typename?: 'BookingAttendeeType', email: string, name?: string | null, optional?: boolean | null, status?: string | null, proposedDate?: string | null, proposedFrom?: string | null, proposedTo?: string | null }>, attachments: Array<{ __typename?: 'BookingAttachmentType', name: string, url?: string | null }>, quote?: { __typename?: 'EVChargerQuote', id: number, estimateNumber: string, totalCost: number, chargerModel: string, stage: string } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type ResendClientLinkMutationVariables = Exact<{
  quoteId: Scalars['Int']['input'];
}>;


export type ResendClientLinkMutation = { __typename?: 'Mutation', resendClientLink: { __typename?: 'ResendClientLinkResponse', sent: boolean, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type RespondToBookingMutationVariables = Exact<{
  bookingId: Scalars['Int']['input'];
  response: Scalars['String']['input'];
  proposedDate?: InputMaybe<Scalars['String']['input']>;
  proposedFrom?: InputMaybe<Scalars['String']['input']>;
  proposedTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type RespondToBookingMutation = { __typename?: 'Mutation', respondToBooking: { __typename?: 'BookingResponse', booking?: { __typename?: 'Booking', id: number, vendorId?: number | null, title: string, type: string, date: string, fromTime: string, toTime: string, allDay: boolean, location?: string | null, description?: string | null, status: string, meetingLink?: string | null, vendorNote?: string | null, createdByName?: string | null, createdByRole?: string | null, createdAt: string, attendees: Array<{ __typename?: 'BookingAttendeeType', email: string, name?: string | null, optional?: boolean | null, status?: string | null, proposedDate?: string | null, proposedFrom?: string | null, proposedTo?: string | null }>, attachments: Array<{ __typename?: 'BookingAttachmentType', name: string, url?: string | null }>, quote?: { __typename?: 'EVChargerQuote', id: number, estimateNumber: string, totalCost: number, chargerModel: string, stage: string } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type RespondToQuoteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  response: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type RespondToQuoteMutation = { __typename?: 'Mutation', respondToQuote: { __typename?: 'EVChargerQuoteResponse', errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null, quote?: { __typename?: 'EVChargerQuote', id: number, approvalStatus: QuoteApprovalStatus, approvalRespondedAt?: string | null, changeRequestNote?: string | null, userAccepted: boolean } | null } };

export type ResubmitVendorApplicationMutationVariables = Exact<{ [key: string]: never; }>;


export type ResubmitVendorApplicationMutation = { __typename?: 'Mutation', resubmitVendorApplication: { __typename?: 'VendorResponse', vendor?: { __typename?: 'Vendor', id: number, verificationStatus: VendorVerification, rejectionReason?: string | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type ReviseQuoteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ReviseQuoteInput;
}>;


export type ReviseQuoteMutation = { __typename?: 'Mutation', reviseQuote: { __typename?: 'EVChargerQuoteResponse', errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null, quote?: { __typename?: 'EVChargerQuote', id: number, stage: string, approvalStatus: QuoteApprovalStatus, approvalRespondedAt?: string | null, changeRequestNote?: string | null, userAccepted: boolean, chargerModel: string, chargerCost: number, installationCost: number, subtotal: number, taxRate: number, taxAmount: number, taxLabel: string, totalCost: number, inclusions: Array<string>, assumptions: Array<string>, notes: Array<string>, paymentTerms?: string | null, expiresAt?: string | null, isExpired: boolean, updatedAt: string, addOns: Array<{ __typename?: 'QuoteAddOn', label: string, price: number }> } | null } };

export type SendEmailVerificationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendEmailVerificationMutation = { __typename?: 'Mutation', sendEmailVerification: { __typename?: 'EmailVerificationResponse', success?: boolean | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type SendMessageMutationVariables = Exact<{
  options: SendMessageInput;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'SendMessageResponse', message?: { __typename?: 'MessageView', id: number, conversationId: number, senderSide: string, senderName: string, senderAvatarUrl?: string | null, body: string, createdAt: string, attachments: Array<{ __typename?: 'MessageAttachmentType', name: string, url: string }> } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type SetConversationArchivedMutationVariables = Exact<{
  conversationId: Scalars['Int']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type SetConversationArchivedMutation = { __typename?: 'Mutation', setConversationArchived?: { __typename?: 'ConversationView', id: number, otherPartyName: string, otherPartyAvatarUrl?: string | null, lastMessageBody?: string | null, lastMessageAt?: string | null, unreadCount: number, starred: boolean, archived: boolean } | null };

export type SetConversationStarredMutationVariables = Exact<{
  conversationId: Scalars['Int']['input'];
  starred: Scalars['Boolean']['input'];
}>;


export type SetConversationStarredMutation = { __typename?: 'Mutation', setConversationStarred?: { __typename?: 'ConversationView', id: number, otherPartyName: string, otherPartyAvatarUrl?: string | null, lastMessageBody?: string | null, lastMessageAt?: string | null, unreadCount: number, starred: boolean, archived: boolean } | null };

export type SetPreferredLanguageMutationVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type SetPreferredLanguageMutation = { __typename?: 'Mutation', setPreferredLanguage: { __typename?: 'AccountResponse', account?: { __typename?: 'Account', id: number, preferredLanguage?: string | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type SetTicketStatusMutationVariables = Exact<{
  ticketId: Scalars['Int']['input'];
  status: TicketStatus;
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetTicketStatusMutation = { __typename?: 'Mutation', setTicketStatus: { __typename?: 'SupportTicketResponse', ticket?: { __typename?: 'SupportTicketView', id: number, subject: string, category: TicketCategory, status: TicketStatus, createdAt: string, lastActivityAt: string, unreadCount: number, lastCommentBody?: string | null, requesterAccountId: number, requesterName: string, requesterEmail: string, requesterRole: string, requesterBusinessName?: string | null, portalVendorName?: string | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type SetVendorAvailabilityMutationVariables = Exact<{
  input: SetVendorAvailabilityInput;
}>;


export type SetVendorAvailabilityMutation = { __typename?: 'Mutation', setVendorAvailability: { __typename?: 'VendorAvailabilityResponse', availability?: { __typename?: 'VendorAvailability', id: number, bufferMinutes: number, bookingHorizon: string, allowSameDayBookings: boolean, weekly: { __typename?: 'WeeklyAvailabilityType', mon: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, tue: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, wed: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, thu: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, fri: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, sat: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, sun: { __typename?: 'DayHoursType', available: boolean, from: string, to: string } }, customDates: Array<{ __typename?: 'CustomDateType', id: string, mode: string, date?: string | null, startDate?: string | null, endDate?: string | null, availability: string, from?: string | null, to?: string | null, note?: string | null, perDay?: Array<{ __typename?: 'PerDayHoursType', date: string, available: boolean, from: string, to: string }> | null }> } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type StartConversationMutationVariables = Exact<{
  otherPartyId: Scalars['Int']['input'];
}>;


export type StartConversationMutation = { __typename?: 'Mutation', startConversation: { __typename?: 'ConversationResponse', conversation?: { __typename?: 'ConversationView', id: number, otherPartyName: string, otherPartyAvatarUrl?: string | null, lastMessageBody?: string | null, lastMessageAt?: string | null, unreadCount: number, starred: boolean, archived: boolean } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type UpdateAccountMutationVariables = Exact<{
  options: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'AccountResponse', account?: { __typename?: 'Account', id: number, email: string, firstName: string, lastName: string, userType: string, googleId?: string | null, authProvider?: string | null, phoneNumber: string, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, profilePhotoUrl?: string | null, jobTitle?: string | null, accessLevel?: string | null, onboardingCompleted: boolean, preferredLanguage?: string | null, isAdmin: boolean, createdAt: string, updatedAt: string, vendor?: { __typename?: 'Vendor', id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type UpdateBookingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: BookingInput;
}>;


export type UpdateBookingMutation = { __typename?: 'Mutation', updateBooking: { __typename?: 'BookingResponse', booking?: { __typename?: 'Booking', id: number, vendorId?: number | null, title: string, type: string, date: string, fromTime: string, toTime: string, allDay: boolean, location?: string | null, description?: string | null, status: string, meetingLink?: string | null, vendorNote?: string | null, createdByName?: string | null, createdByRole?: string | null, createdAt: string, attendees: Array<{ __typename?: 'BookingAttendeeType', email: string, name?: string | null, optional?: boolean | null, status?: string | null, proposedDate?: string | null, proposedFrom?: string | null, proposedTo?: string | null }>, attachments: Array<{ __typename?: 'BookingAttachmentType', name: string, url?: string | null }>, quote?: { __typename?: 'EVChargerQuote', id: number, estimateNumber: string, totalCost: number, chargerModel: string, stage: string } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type UpdateEvChargerServiceMutationVariables = Exact<{
  id: Scalars['Float']['input'];
  options: EvChargerServiceInput;
}>;


export type UpdateEvChargerServiceMutation = { __typename?: 'Mutation', updateEVChargerService: { __typename?: 'EVChargerServiceResponse', errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null, evChargerService?: { __typename?: 'EVChargerService', id: number, areaServiced?: number | null, quoteValidFor: string, paymentTerms?: string | null, updatedAt: string } | null } };

export type UpdateMyQuoteMutationVariables = Exact<{
  id: Scalars['Float']['input'];
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMyQuoteMutation = { __typename?: 'Mutation', updateMyQuote?: { __typename?: 'EVChargerQuote', id: number, starred?: boolean | null, archived?: boolean | null, viewed?: boolean | null } | null };

export type UpdatePrivatePortalMutationVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePrivatePortalMutation = { __typename?: 'Mutation', updatePrivatePortal: { __typename?: 'PrivatePortalSettingsResponse', portalUrl?: string | null, vendor?: { __typename?: 'Vendor', id: number, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type UpdateQuoteMutationVariables = Exact<{
  id: Scalars['Float']['input'];
  stage?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateQuoteMutation = { __typename?: 'Mutation', updateQuote?: { __typename?: 'EVChargerQuote', id: number, stage: string, assignedTo: string, starred?: boolean | null, archived?: boolean | null, viewed?: boolean | null } | null };

export type UpdateVendorMutationVariables = Exact<{
  options: UpdateVendorInput;
}>;


export type UpdateVendorMutation = { __typename?: 'Mutation', updateVendor: { __typename?: 'VendorResponse', vendor?: { __typename?: 'Vendor', id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null, warnings?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type UploadFileMutationVariables = Exact<{
  options: FileUploadInput;
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'FileUploadResponse', url?: string | null, error?: string | null } };

export type VerifyEmailCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyEmailCodeMutation = { __typename?: 'Mutation', verifyEmailCode: { __typename?: 'EmailVerificationResponse', success?: boolean | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message?: string | null }> | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'Account', id: number, email: string, firstName: string, lastName: string, userType: string, googleId?: string | null, authProvider?: string | null, phoneNumber: string, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, profilePhotoUrl?: string | null, jobTitle?: string | null, accessLevel?: string | null, onboardingCompleted: boolean, preferredLanguage?: string | null, isAdmin: boolean, createdAt: string, updatedAt: string, vendor?: { __typename?: 'Vendor', id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } | null } | null };

export type AdminExpiringVendorsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminExpiringVendorsQuery = { __typename?: 'Query', adminExpiringVendors: Array<{ __typename?: 'AdminVendorView', id: number, googleLinkStatus: GoogleLinkReview, suspendedAt?: string | null, ownerName?: string | null, ownerEmail?: string | null, accountCount: number, reviewListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null, vendor: { __typename?: 'Vendor', phoneNumber: string, id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } }> };

export type AdminSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminSummaryQuery = { __typename?: 'Query', adminSummary: { __typename?: 'AdminSummary', pendingGoogleReviews: number, unverifiedVendors: number, openTickets: number } };

export type AdminUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  suspendedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminUsersQuery = { __typename?: 'Query', adminUsers: { __typename?: 'AdminUserPage', total: number, items: Array<{ __typename?: 'AdminUserView', id: number, suspendedAt?: string | null, portalVendorName?: string | null, isAdmin: boolean, account: { __typename?: 'Account', id: number, email: string, firstName: string, lastName: string, phoneNumber: string, address: string, profilePhotoUrl?: string | null, authProvider?: string | null, createdAt: string } }> } };

export type AdminVendorsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminVendorFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminVendorsQuery = { __typename?: 'Query', adminVendors: { __typename?: 'AdminVendorPage', total: number, items: Array<{ __typename?: 'AdminVendorView', id: number, googleLinkStatus: GoogleLinkReview, suspendedAt?: string | null, ownerName?: string | null, ownerEmail?: string | null, accountCount: number, reviewListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null, vendor: { __typename?: 'Vendor', phoneNumber: string, id: number, businessName: string, operatingAs?: string | null, mailingSameAsBusiness: boolean, mailingAddress?: string | null, address: string, latitude?: number | null, longitude?: number | null, placeId?: string | null, businessWebsite?: string | null, organizationType: string, primaryContactFirstName: string, primaryContactLastName: string, primaryContactPosition: string, primaryContactEmail: string, primaryContactPhone: string, notificationEmail?: string | null, primaryContactIsSignatory: boolean, signatoryFirstName?: string | null, signatoryLastName?: string | null, signatoryPosition?: string | null, signatoryEmail?: string | null, signatoryPhone?: string | null, businessNumber: string, proofOfInsuranceURL: string, insuranceExpiryDate?: string | null, businessLicenseURL: string, offeringEvInstallation: string, province: string, electricalLicenseURL?: string | null, electricalLicenseNumber?: string | null, electricalLicenseExpiryDate?: string | null, expiryReminderEnabled: boolean, insuranceReminderSentAt?: string | null, licenseReminderSentAt?: string | null, onboardingStep?: string | null, agreementAcceptedAt?: string | null, termsAcceptedAt?: string | null, termsVersion?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, brandGoogleReview?: string | null, publicEmail?: string | null, publicPhone?: string | null, googlePlaceId?: string | null, isVerified: boolean, verificationStatus: VendorVerification, rejectionReason?: string | null, pausedAt?: string | null, pauseReason?: string | null, reverificationRequestedAt?: string | null, reverificationReasons: Array<string>, slug?: string | null, privatePortalEnabled: boolean, portalLanguage?: string | null, createdAt: string, updatedAt: string, expiringDocuments: Array<{ __typename?: 'ExpiringDocument', kind: string, label: string, expiryDate: string, daysLeft: number }>, privatePortalService?: { __typename?: 'EVChargerService', id: number } | null } }> } };

export type AnalyticsOverviewQueryVariables = Exact<{
  days: Scalars['Int']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
}>;


export type AnalyticsOverviewQuery = { __typename?: 'Query', analyticsOverview: { __typename?: 'AnalyticsOverview', uniqueVisitors: number, pageviews: number, signups: number, estimatorStarts: number, estimatorSubmissions: number, errors: number } };

export type AnalyticsTimeseriesQueryVariables = Exact<{
  days: Scalars['Int']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
}>;


export type AnalyticsTimeseriesQuery = { __typename?: 'Query', analyticsTimeseries: Array<{ __typename?: 'AnalyticsTimeseriesPoint', date: string, visitors: number, pageviews: number }> };

export type AnalyticsBreakdownsQueryVariables = Exact<{
  days: Scalars['Int']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
}>;


export type AnalyticsBreakdownsQuery = { __typename?: 'Query', analyticsBreakdowns: { __typename?: 'AnalyticsBreakdowns', countries: Array<{ __typename?: 'AnalyticsBreakdownRow', label: string, visitors: number, events: number }>, regions: Array<{ __typename?: 'AnalyticsBreakdownRow', label: string, visitors: number, events: number }>, cities: Array<{ __typename?: 'AnalyticsBreakdownRow', label: string, visitors: number, events: number }>, pages: Array<{ __typename?: 'AnalyticsBreakdownRow', label: string, visitors: number, events: number }>, devices: Array<{ __typename?: 'AnalyticsBreakdownRow', label: string, visitors: number, events: number }>, browsers: Array<{ __typename?: 'AnalyticsBreakdownRow', label: string, visitors: number, events: number }>, referrers: Array<{ __typename?: 'AnalyticsBreakdownRow', label: string, visitors: number, events: number }> } };

export type AnalyticsFunnelQueryVariables = Exact<{
  days: Scalars['Int']['input'];
}>;


export type AnalyticsFunnelQuery = { __typename?: 'Query', analyticsFunnel: Array<{ __typename?: 'AnalyticsFunnelStep', step: string, index?: number | null, visitors: number }> };

export type MarketplaceHealthQueryVariables = Exact<{
  days: Scalars['Int']['input'];
}>;


export type MarketplaceHealthQuery = { __typename?: 'Query', marketplaceHealth: { __typename?: 'MarketplaceHealth', newUsers: number, newVendors: number, serviceRequests: number, quotesSent: number, quotesApproved: number, bookings: number } };

export type GetVendorAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVendorAvailabilityQuery = { __typename?: 'Query', vendorAvailability?: { __typename?: 'VendorAvailability', id: number, bufferMinutes: number, bookingHorizon: string, allowSameDayBookings: boolean, weekly: { __typename?: 'WeeklyAvailabilityType', mon: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, tue: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, wed: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, thu: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, fri: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, sat: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, sun: { __typename?: 'DayHoursType', available: boolean, from: string, to: string } }, customDates: Array<{ __typename?: 'CustomDateType', id: string, mode: string, date?: string | null, startDate?: string | null, endDate?: string | null, availability: string, from?: string | null, to?: string | null, note?: string | null, perDay?: Array<{ __typename?: 'PerDayHoursType', date: string, available: boolean, from: string, to: string }> | null }> } | null };

export type VendorAvailabilityForQuoteQueryVariables = Exact<{
  quoteId: Scalars['Int']['input'];
}>;


export type VendorAvailabilityForQuoteQuery = { __typename?: 'Query', vendorAvailabilityForQuote?: { __typename?: 'QuoteVendorAvailability', availabilityConfigured: boolean, availability?: { __typename?: 'VendorAvailability', id: number, bufferMinutes: number, bookingHorizon: string, allowSameDayBookings: boolean, weekly: { __typename?: 'WeeklyAvailabilityType', mon: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, tue: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, wed: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, thu: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, fri: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, sat: { __typename?: 'DayHoursType', available: boolean, from: string, to: string }, sun: { __typename?: 'DayHoursType', available: boolean, from: string, to: string } }, customDates: Array<{ __typename?: 'CustomDateType', id: string, mode: string, date?: string | null, startDate?: string | null, endDate?: string | null, availability: string, from?: string | null, to?: string | null, note?: string | null, perDay?: Array<{ __typename?: 'PerDayHoursType', date: string, available: boolean, from: string, to: string }> | null }> } | null, busySlots: Array<{ __typename?: 'BookingBusySlot', date: string, fromTime: string, toTime: string, allDay: boolean }> } | null };

export type MyInvitedBookingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyInvitedBookingsQuery = { __typename?: 'Query', myInvitedBookings: Array<{ __typename?: 'Booking', id: number, vendorId?: number | null, title: string, type: string, date: string, fromTime: string, toTime: string, allDay: boolean, location?: string | null, description?: string | null, status: string, meetingLink?: string | null, vendorNote?: string | null, createdByName?: string | null, createdByRole?: string | null, createdAt: string, attendees: Array<{ __typename?: 'BookingAttendeeType', email: string, name?: string | null, optional?: boolean | null, status?: string | null, proposedDate?: string | null, proposedFrom?: string | null, proposedTo?: string | null }>, attachments: Array<{ __typename?: 'BookingAttachmentType', name: string, url?: string | null }>, quote?: { __typename?: 'EVChargerQuote', id: number, estimateNumber: string, totalCost: number, chargerModel: string, stage: string } | null }> };

export type VendorBookingsQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorBookingsQuery = { __typename?: 'Query', vendorBookings: Array<{ __typename?: 'Booking', id: number, vendorId?: number | null, title: string, type: string, date: string, fromTime: string, toTime: string, allDay: boolean, location?: string | null, description?: string | null, status: string, meetingLink?: string | null, vendorNote?: string | null, createdByName?: string | null, createdByRole?: string | null, createdAt: string, attendees: Array<{ __typename?: 'BookingAttendeeType', email: string, name?: string | null, optional?: boolean | null, status?: string | null, proposedDate?: string | null, proposedFrom?: string | null, proposedTo?: string | null }>, attachments: Array<{ __typename?: 'BookingAttachmentType', name: string, url?: string | null }>, quote?: { __typename?: 'EVChargerQuote', id: number, estimateNumber: string, totalCost: number, chargerModel: string, stage: string } | null }> };

export type EvListQueryVariables = Exact<{ [key: string]: never; }>;


export type EvListQuery = { __typename?: 'Query', getEVList?: Array<{ __typename?: 'EV', id: number, modelYear: number, make: string, model: string, vehicleClass?: string | null, motor?: number | null, transmission?: string | null, fuelType?: string | null, cityEnergyConsumption?: number | null, highwayEnergyConsumption?: number | null, combinedEnergyConsumption?: number | null, cityFuelConsumptionLe?: number | null, highwayFuelConsumptionLe?: number | null, combinedFuelConsumptionLe?: number | null, range?: number | null, co2Emissions?: number | null, co2Rating?: number | null, smogRating?: number | null, rechargeTime?: number | null }> | null };

export type GetEvChargerServiceListQueryVariables = Exact<{
  vehicleType?: InputMaybe<Scalars['String']['input']>;
  houseType?: InputMaybe<Scalars['String']['input']>;
  evseType?: InputMaybe<Scalars['String']['input']>;
  wireLength?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEvChargerServiceListQuery = { __typename?: 'Query', getEVChargerServiceList?: Array<{ __typename?: 'EVChargerService', id: number, areaServiced?: number | null, quoteValidFor: string, paymentTerms?: string | null, createdAt: string, updatedAt: string, evChargerServiceFields?: Array<{ __typename?: 'EVChargerServiceField', id: number, fieldLabel: string, customLabel?: string | null, price?: number | null, isChecked: boolean, duplicates: boolean, placeholder?: string | null, fieldType: string, fieldName: string, createdAt: string, updatedAt: string }> | null, vendor: { __typename?: 'Vendor', id: number, businessName: string } }> | null };

export type GetEvChargerServiceListByVendorQueryVariables = Exact<{
  vendorId: Scalars['Float']['input'];
}>;


export type GetEvChargerServiceListByVendorQuery = { __typename?: 'Query', getEVChargerServiceListByVendor?: Array<{ __typename?: 'EVChargerService', id: number, areaServiced?: number | null, quoteValidFor: string, paymentTerms?: string | null, createdAt: string, updatedAt: string, evChargerServiceFields?: Array<{ __typename?: 'EVChargerServiceField', id: number, fieldLabel: string, customLabel?: string | null, price?: number | null, isChecked: boolean, duplicates: boolean, placeholder?: string | null, fieldType: string, fieldName: string, createdAt: string, updatedAt: string }> | null, vendor: { __typename?: 'Vendor', id: number, businessName: string } }> | null };

export type GetEvChargerServiceRecommendationsQueryVariables = Exact<{
  vehicleType?: InputMaybe<Scalars['String']['input']>;
  houseType?: InputMaybe<Scalars['String']['input']>;
  evseType?: InputMaybe<Scalars['String']['input']>;
  wireLength?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<EvChargerServiceSortBy>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  userLat?: InputMaybe<Scalars['Float']['input']>;
  userLng?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetEvChargerServiceRecommendationsQuery = { __typename?: 'Query', getEVChargerServiceRecommendations?: Array<{ __typename?: 'EVChargerService', id: number, areaServiced?: number | null, quoteValidFor: string, paymentTerms?: string | null, distanceKm?: number | null, createdAt: string, updatedAt: string, evChargerServiceFields?: Array<{ __typename?: 'EVChargerServiceField', id: number, fieldLabel: string, customLabel?: string | null, price?: number | null, isChecked: boolean, duplicates: boolean, placeholder?: string | null, fieldType: string, fieldName: string, createdAt: string, updatedAt: string }> | null, vendor: { __typename?: 'Vendor', id: number, address: string, latitude?: number | null, longitude?: number | null, publicEmail?: string | null, publicPhone?: string | null, businessWebsite?: string | null, businessNumber: string, brandLogoURL?: string | null, brandAbout?: string | null, isVerified: boolean, businessName: string, googleListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null } }> | null };

export type GetLeadsByVendorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadsByVendorQuery = { __typename?: 'Query', getLeadsByVendor: Array<{ __typename?: 'EVChargerQuote', id: number, distance: string, stage: string, assignedTo: string, starred?: boolean | null, archived?: boolean | null, viewed?: boolean | null, createdAt: string, expiresAt?: string | null, isExpired: boolean, estimateNumber: string, userAccepted: boolean, approvalStatus: QuoteApprovalStatus, approvalRespondedAt?: string | null, changeRequestNote?: string | null, chargerModel: string, chargerCost: number, installationCost: number, subtotal: number, taxRate: number, taxAmount: number, taxLabel: string, totalCost: number, inclusions: Array<string>, assumptions: Array<string>, notes: Array<string>, paymentTerms?: string | null, addOns: Array<{ __typename?: 'QuoteAddOn', label: string, price: number }>, evChargerService: { __typename?: 'EVChargerService', id: number, quoteValidFor: string, vendor: { __typename?: 'Vendor', id: number, businessName: string, address: string, phoneNumber: string, businessWebsite?: string | null, brandLogoURL?: string | null, brandAbout?: string | null, googleListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null } }, chargerServiceRequest: { __typename?: 'EVChargerServiceRequest', id: number, address: string, createdAt: string, installationType: string, vehicleType?: string | null, houseType: string, chargerLocation: string, chargerSetup: string, electricalPanelLocation: string, mainServiceSize: string, electricalPanelPhotoURL: string, mainBreakerPhotoURL: string, wireLength: string, purchaseType: string, elevator: boolean, pool: boolean, hotTub: boolean, additionalInformation?: string | null, account: { __typename?: 'Account', id: number, firstName: string, lastName: string, email: string, phoneNumber: string, invitedByVendor?: { __typename?: 'Vendor', id: number } | null } } }> };

export type GetQuotesByAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuotesByAccountQuery = { __typename?: 'Query', getQuotesByAccount: Array<{ __typename?: 'EVChargerQuote', id: number, estimateNumber: string, userAccepted: boolean, approvalStatus: QuoteApprovalStatus, starred?: boolean | null, archived?: boolean | null, viewed?: boolean | null, approvalRespondedAt?: string | null, changeRequestNote?: string | null, distance: string, chargerModel: string, chargerCost: number, installationCost: number, subtotal: number, taxRate: number, taxAmount: number, taxLabel: string, totalCost: number, inclusions: Array<string>, assumptions: Array<string>, notes: Array<string>, paymentTerms?: string | null, expiresAt?: string | null, isExpired: boolean, createdAt: string, updatedAt: string, addOns: Array<{ __typename?: 'QuoteAddOn', label: string, price: number }>, evChargerService: { __typename?: 'EVChargerService', id: number, quoteValidFor: string, vendor: { __typename?: 'Vendor', id: number, address: string, publicEmail?: string | null, publicPhone?: string | null, businessWebsite?: string | null, businessNumber: string, brandLogoURL?: string | null, brandAbout?: string | null, isVerified: boolean, businessName: string, googleListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null } }, chargerServiceRequest: { __typename?: 'EVChargerServiceRequest', id: number, address: string, installationType: string, vehicleType?: string | null, houseType: string, chargerLocation: string, chargerSetup: string, electricalPanelLocation: string, mainServiceSize: string, electricalPanelPhotoURL: string, mainBreakerPhotoURL: string, wireLength: string, purchaseType: string, elevator: boolean, pool: boolean, hotTub: boolean, additionalInformation?: string | null } }> };

export type IceListQueryVariables = Exact<{ [key: string]: never; }>;


export type IceListQuery = { __typename?: 'Query', getICEList?: Array<{ __typename?: 'ICE', id: number, modelYear: number, make: string, model: string, vehicleClass?: string | null, engineSize?: number | null, cylinders?: number | null, transmission?: string | null, fuelType?: string | null, cityFuelConsumption?: number | null, highwayFuelConsumption?: number | null, combinedFuelConsumption?: number | null, combinedMPG?: number | null, co2Emissions?: number | null, co2Rating?: number | null, smogRating?: number | null }> | null };

export type GetIceVehicleQueryVariables = Exact<{
  iceVehicleId: Scalars['Float']['input'];
}>;


export type GetIceVehicleQuery = { __typename?: 'Query', getICEVehicle?: { __typename?: 'ICE', id: number, modelYear: number, make: string, model: string, vehicleClass?: string | null, engineSize?: number | null, cylinders?: number | null, transmission?: string | null, fuelType?: string | null, cityFuelConsumption?: number | null, highwayFuelConsumption?: number | null, combinedFuelConsumption?: number | null, combinedMPG?: number | null, co2Emissions?: number | null, co2Rating?: number | null, smogRating?: number | null } | null };

export type GetConversationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConversationsQuery = { __typename?: 'Query', getConversations: Array<{ __typename?: 'ConversationView', id: number, otherPartyName: string, otherPartyAvatarUrl?: string | null, lastMessageBody?: string | null, lastMessageAt?: string | null, unreadCount: number, starred: boolean, archived: boolean }> };

export type GetMessageableCounterpartsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMessageableCounterpartsQuery = { __typename?: 'Query', getMessageableCounterparts: Array<{ __typename?: 'MessageableCounterpart', otherPartyId: number, name: string, avatarUrl?: string | null, conversationId?: number | null }> };

export type GetMessagesQueryVariables = Exact<{
  conversationId: Scalars['Int']['input'];
  beforeId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMessagesQuery = { __typename?: 'Query', getMessages: { __typename?: 'MessagesPage', hasMore: boolean, messages: Array<{ __typename?: 'MessageView', id: number, conversationId: number, senderSide: string, senderName: string, senderAvatarUrl?: string | null, body: string, createdAt: string, attachments: Array<{ __typename?: 'MessageAttachmentType', name: string, url: string }> }> } };

export type PhevListQueryVariables = Exact<{ [key: string]: never; }>;


export type PhevListQuery = { __typename?: 'Query', getPHEVList?: Array<{ __typename?: 'PHEV', id: number, modelYear: number, make: string, model: string, vehicleClass?: string | null, motor?: number | null, engineSize?: number | null, cylinders?: number | null, transmission?: string | null, fuelType1?: string | null, fuelType2?: string | null, combinedLe?: string | null, range1?: number | null, range2?: number | null, rechargeTime?: number | null, cityFuelConsumption?: number | null, highwayFuelConsumption?: number | null, combinedFuelConsumption?: number | null, co2Emissions?: number | null, co2Rating?: number | null, smogRating?: number | null }> | null };

export type AdminTicketsQueryVariables = Exact<{
  status?: InputMaybe<TicketStatus>;
}>;


export type AdminTicketsQuery = { __typename?: 'Query', adminTickets: Array<{ __typename?: 'SupportTicketView', id: number, subject: string, category: TicketCategory, status: TicketStatus, createdAt: string, lastActivityAt: string, unreadCount: number, lastCommentBody?: string | null, requesterAccountId: number, requesterName: string, requesterEmail: string, requesterRole: string, requesterBusinessName?: string | null, portalVendorName?: string | null }> };

export type MyTicketsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTicketsQuery = { __typename?: 'Query', myTickets: Array<{ __typename?: 'SupportTicketView', id: number, subject: string, category: TicketCategory, status: TicketStatus, createdAt: string, lastActivityAt: string, unreadCount: number, lastCommentBody?: string | null, requesterAccountId: number, requesterName: string, requesterEmail: string, requesterRole: string, requesterBusinessName?: string | null, portalVendorName?: string | null }> };

export type SupportTicketQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SupportTicketQuery = { __typename?: 'Query', supportTicket?: { __typename?: 'SupportTicketView', id: number, subject: string, category: TicketCategory, status: TicketStatus, createdAt: string, lastActivityAt: string, unreadCount: number, lastCommentBody?: string | null, requesterAccountId: number, requesterName: string, requesterEmail: string, requesterRole: string, requesterBusinessName?: string | null, portalVendorName?: string | null } | null };

export type SupportUnreadCountQueryVariables = Exact<{
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SupportUnreadCountQuery = { __typename?: 'Query', supportUnreadCount: number };

export type TicketCommentsQueryVariables = Exact<{
  ticketId: Scalars['Int']['input'];
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TicketCommentsQuery = { __typename?: 'Query', ticketComments: Array<{ __typename?: 'TicketCommentView', id: number, ticketId: number, fromAdmin: boolean, authorName: string, authorAvatarUrl?: string | null, body: string, createdAt: string, attachments: Array<{ __typename?: 'MessageAttachmentType', name: string, url: string }> }> };

export type VendorGoogleListingQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type VendorGoogleListingQuery = { __typename?: 'Query', vendor?: { __typename?: 'Vendor', id: number, googlePlaceId?: string | null, googleListingStatus: GoogleListingStatus, googleListing?: { __typename?: 'GoogleListing', placeName?: string | null, rating?: number | null, reviewCount: number, reviewsUrl: string } | null } | null };

export type MessageSentSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MessageSentSubscription = { __typename?: 'Subscription', messageSent: { __typename?: 'MessageView', id: number, conversationId: number, senderSide: string, senderName: string, senderAvatarUrl?: string | null, body: string, createdAt: string, attachments: Array<{ __typename?: 'MessageAttachmentType', name: string, url: string }> } };

export type QuoteCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type QuoteCreatedSubscription = { __typename?: 'Subscription', quoteCreated: { __typename?: 'QuoteCreatedEvent', quoteId: number } };

export type QuoteUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type QuoteUpdatedSubscription = { __typename?: 'Subscription', quoteUpdated: { __typename?: 'QuoteCreatedEvent', quoteId: number } };

export type SupportTicketChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SupportTicketChangedSubscription = { __typename?: 'Subscription', supportTicketChanged: number };

export const VendorFragmentDoc = gql`
    fragment Vendor on Vendor {
  id
  businessName
  operatingAs
  mailingSameAsBusiness
  mailingAddress
  address
  latitude
  longitude
  placeId
  businessWebsite
  organizationType
  primaryContactFirstName
  primaryContactLastName
  primaryContactPosition
  primaryContactEmail
  primaryContactPhone
  notificationEmail
  primaryContactIsSignatory
  signatoryFirstName
  signatoryLastName
  signatoryPosition
  signatoryEmail
  signatoryPhone
  businessNumber
  proofOfInsuranceURL
  insuranceExpiryDate
  businessLicenseURL
  offeringEvInstallation
  province
  electricalLicenseURL
  electricalLicenseNumber
  electricalLicenseExpiryDate
  expiryReminderEnabled
  insuranceReminderSentAt
  licenseReminderSentAt
  expiringDocuments {
    kind
    label
    expiryDate
    daysLeft
  }
  onboardingStep
  agreementAcceptedAt
  termsAcceptedAt
  termsVersion
  brandLogoURL
  brandAbout
  brandGoogleReview
  publicEmail
  publicPhone
  googlePlaceId
  isVerified
  verificationStatus
  rejectionReason
  pausedAt
  pauseReason
  reverificationRequestedAt
  reverificationReasons
  slug
  privatePortalEnabled
  portalLanguage
  privatePortalService {
    id
  }
  createdAt
  updatedAt
}
    `;
export const AccountFragmentDoc = gql`
    fragment Account on Account {
  id
  email
  firstName
  lastName
  userType
  googleId
  authProvider
  phoneNumber
  address
  latitude
  longitude
  placeId
  profilePhotoUrl
  jobTitle
  accessLevel
  onboardingCompleted
  preferredLanguage
  isAdmin
  vendor {
    ...Vendor
  }
  createdAt
  updatedAt
}
    ${VendorFragmentDoc}`;
export const AdminUserFragmentDoc = gql`
    fragment AdminUser on AdminUserView {
  id
  suspendedAt
  portalVendorName
  isAdmin
  account {
    id
    email
    firstName
    lastName
    phoneNumber
    address
    profilePhotoUrl
    authProvider
    createdAt
  }
}
    `;
export const GoogleListingFragmentDoc = gql`
    fragment GoogleListing on GoogleListing {
  placeName
  rating
  reviewCount
  reviewsUrl
}
    `;
export const AdminVendorFragmentDoc = gql`
    fragment AdminVendor on AdminVendorView {
  id
  googleLinkStatus
  suspendedAt
  ownerName
  ownerEmail
  accountCount
  reviewListing {
    ...GoogleListing
  }
  vendor {
    ...Vendor
    phoneNumber
  }
}
    ${GoogleListingFragmentDoc}
${VendorFragmentDoc}`;
export const AnalyticsBreakdownRowFragmentDoc = gql`
    fragment AnalyticsBreakdownRow on AnalyticsBreakdownRow {
  label
  visitors
  events
}
    `;
export const BookingFragmentDoc = gql`
    fragment Booking on Booking {
  id
  vendorId
  title
  type
  date
  fromTime
  toTime
  allDay
  location
  description
  attendees {
    email
    name
    optional
    status
    proposedDate
    proposedFrom
    proposedTo
  }
  attachments {
    name
    url
  }
  status
  meetingLink
  vendorNote
  quote {
    id
    estimateNumber
    totalCost
    chargerModel
    stage
  }
  createdByName
  createdByRole
  createdAt
}
    `;
export const ConversationFragmentDoc = gql`
    fragment Conversation on ConversationView {
  id
  otherPartyName
  otherPartyAvatarUrl
  lastMessageBody
  lastMessageAt
  unreadCount
  starred
  archived
}
    `;
export const FileUploadFragmentDoc = gql`
    fragment FileUpload on FileUploadResponse {
  url
  error
}
    `;
export const MessageFragmentDoc = gql`
    fragment Message on MessageView {
  id
  conversationId
  senderSide
  senderName
  senderAvatarUrl
  body
  attachments {
    name
    url
  }
  createdAt
}
    `;
export const RegularErrorFragmentDoc = gql`
    fragment RegularError on FieldError {
  field
  message
}
    `;
export const SupportTicketFragmentDoc = gql`
    fragment SupportTicket on SupportTicketView {
  id
  subject
  category
  status
  createdAt
  lastActivityAt
  unreadCount
  lastCommentBody
  requesterAccountId
  requesterName
  requesterEmail
  requesterRole
  requesterBusinessName
  portalVendorName
}
    `;
export const TicketCommentFragmentDoc = gql`
    fragment TicketComment on TicketCommentView {
  id
  ticketId
  fromAdmin
  authorName
  authorAvatarUrl
  body
  attachments {
    name
    url
  }
  createdAt
}
    `;
export const VendorAvailabilityFragmentDoc = gql`
    fragment VendorAvailability on VendorAvailability {
  id
  weekly {
    mon {
      available
      from
      to
    }
    tue {
      available
      from
      to
    }
    wed {
      available
      from
      to
    }
    thu {
      available
      from
      to
    }
    fri {
      available
      from
      to
    }
    sat {
      available
      from
      to
    }
    sun {
      available
      from
      to
    }
  }
  customDates {
    id
    mode
    date
    startDate
    endDate
    availability
    from
    to
    perDay {
      date
      available
      from
      to
    }
    note
  }
  bufferMinutes
  bookingHorizon
  allowSameDayBookings
}
    `;
export const AddTicketCommentDocument = gql`
    mutation AddTicketComment($options: AddTicketCommentInput!) {
  addTicketComment(options: $options) {
    comment {
      ...TicketComment
    }
    errors {
      ...RegularError
    }
  }
}
    ${TicketCommentFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useAddTicketCommentMutation() {
  return Urql.useMutation<AddTicketCommentMutation, AddTicketCommentMutationVariables>(AddTicketCommentDocument);
};
export const AdminApproveReverificationDocument = gql`
    mutation AdminApproveReverification($vendorId: Int!) {
  adminApproveReverification(vendorId: $vendorId) {
    vendor {
      ...AdminVendor
    }
    errors {
      ...RegularError
    }
  }
}
    ${AdminVendorFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useAdminApproveReverificationMutation() {
  return Urql.useMutation<AdminApproveReverificationMutation, AdminApproveReverificationMutationVariables>(AdminApproveReverificationDocument);
};
export const AdminApproveVendorDocument = gql`
    mutation AdminApproveVendor($vendorId: Int!) {
  adminApproveVendor(vendorId: $vendorId) {
    vendor {
      ...AdminVendor
    }
    errors {
      ...RegularError
    }
  }
}
    ${AdminVendorFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useAdminApproveVendorMutation() {
  return Urql.useMutation<AdminApproveVendorMutation, AdminApproveVendorMutationVariables>(AdminApproveVendorDocument);
};
export const AdminSendExpiryReminderDocument = gql`
    mutation AdminSendExpiryReminder($vendorId: Int!) {
  adminSendExpiryReminder(vendorId: $vendorId) {
    vendor {
      ...AdminVendor
    }
    errors {
      ...RegularError
    }
  }
}
    ${AdminVendorFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useAdminSendExpiryReminderMutation() {
  return Urql.useMutation<AdminSendExpiryReminderMutation, AdminSendExpiryReminderMutationVariables>(AdminSendExpiryReminderDocument);
};
export const AdminSetExpiryReminderDocument = gql`
    mutation AdminSetExpiryReminder($vendorId: Int!, $enabled: Boolean!) {
  adminSetExpiryReminder(vendorId: $vendorId, enabled: $enabled) {
    vendor {
      ...AdminVendor
    }
    errors {
      ...RegularError
    }
  }
}
    ${AdminVendorFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useAdminSetExpiryReminderMutation() {
  return Urql.useMutation<AdminSetExpiryReminderMutation, AdminSetExpiryReminderMutationVariables>(AdminSetExpiryReminderDocument);
};
export const AdminRejectVendorDocument = gql`
    mutation AdminRejectVendor($vendorId: Int!, $reason: String!) {
  adminRejectVendor(vendorId: $vendorId, reason: $reason) {
    vendor {
      ...AdminVendor
    }
    errors {
      ...RegularError
    }
  }
}
    ${AdminVendorFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useAdminRejectVendorMutation() {
  return Urql.useMutation<AdminRejectVendorMutation, AdminRejectVendorMutationVariables>(AdminRejectVendorDocument);
};
export const AdminReviewGoogleLinkDocument = gql`
    mutation AdminReviewGoogleLink($vendorId: Int!, $approve: Boolean!) {
  adminReviewGoogleLink(vendorId: $vendorId, approve: $approve) {
    vendor {
      ...AdminVendor
    }
    errors {
      ...RegularError
    }
  }
}
    ${AdminVendorFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useAdminReviewGoogleLinkMutation() {
  return Urql.useMutation<AdminReviewGoogleLinkMutation, AdminReviewGoogleLinkMutationVariables>(AdminReviewGoogleLinkDocument);
};
export const AdminSetAccountSuspendedDocument = gql`
    mutation AdminSetAccountSuspended($accountId: Int!, $suspended: Boolean!) {
  adminSetAccountSuspended(accountId: $accountId, suspended: $suspended) {
    user {
      ...AdminUser
    }
    errors {
      ...RegularError
    }
  }
}
    ${AdminUserFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useAdminSetAccountSuspendedMutation() {
  return Urql.useMutation<AdminSetAccountSuspendedMutation, AdminSetAccountSuspendedMutationVariables>(AdminSetAccountSuspendedDocument);
};
export const AdminSetVendorPausedDocument = gql`
    mutation AdminSetVendorPaused($vendorId: Int!, $paused: Boolean!, $reason: String) {
  adminSetVendorPaused(vendorId: $vendorId, paused: $paused, reason: $reason) {
    vendor {
      ...AdminVendor
    }
    errors {
      ...RegularError
    }
  }
}
    ${AdminVendorFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useAdminSetVendorPausedMutation() {
  return Urql.useMutation<AdminSetVendorPausedMutation, AdminSetVendorPausedMutationVariables>(AdminSetVendorPausedDocument);
};
export const AdminSetVendorSuspendedDocument = gql`
    mutation AdminSetVendorSuspended($vendorId: Int!, $suspended: Boolean!) {
  adminSetVendorSuspended(vendorId: $vendorId, suspended: $suspended) {
    vendor {
      ...AdminVendor
    }
    errors {
      ...RegularError
    }
  }
}
    ${AdminVendorFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useAdminSetVendorSuspendedMutation() {
  return Urql.useMutation<AdminSetVendorSuspendedMutation, AdminSetVendorSuspendedMutationVariables>(AdminSetVendorSuspendedDocument);
};
export const CancelMeetingDocument = gql`
    mutation CancelMeeting($bookingId: Int!, $note: String) {
  cancelMeeting(bookingId: $bookingId, note: $note) {
    booking {
      ...Booking
    }
    errors {
      ...RegularError
    }
  }
}
    ${BookingFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useCancelMeetingMutation() {
  return Urql.useMutation<CancelMeetingMutation, CancelMeetingMutationVariables>(CancelMeetingDocument);
};
export const ConfirmMeetingDocument = gql`
    mutation ConfirmMeeting($bookingId: Int!, $meetingLink: String, $note: String, $newDate: String, $newFrom: String, $newTo: String) {
  confirmMeeting(
    bookingId: $bookingId
    meetingLink: $meetingLink
    note: $note
    newDate: $newDate
    newFrom: $newFrom
    newTo: $newTo
  ) {
    booking {
      ...Booking
    }
    errors {
      ...RegularError
    }
  }
}
    ${BookingFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useConfirmMeetingMutation() {
  return Urql.useMutation<ConfirmMeetingMutation, ConfirmMeetingMutationVariables>(ConfirmMeetingDocument);
};
export const CreateBookingDocument = gql`
    mutation CreateBooking($input: BookingInput!) {
  createBooking(input: $input) {
    booking {
      ...Booking
    }
    errors {
      ...RegularError
    }
  }
}
    ${BookingFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useCreateBookingMutation() {
  return Urql.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument);
};
export const CreateEvChargerServiceDocument = gql`
    mutation CreateEVChargerService($options: EVChargerServiceInput!) {
  createEVChargerService(options: $options) {
    evChargerService {
      id
      vendor {
        id
        businessName
      }
    }
    errors {
      ...RegularError
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useCreateEvChargerServiceMutation() {
  return Urql.useMutation<CreateEvChargerServiceMutation, CreateEvChargerServiceMutationVariables>(CreateEvChargerServiceDocument);
};
export const CreateServiceChargeQuoteDocument = gql`
    mutation CreateServiceChargeQuote($serviceRequestInput: EVChargerServiceRequestInput!, $quoteInput: EVChargerQuoteInput!) {
  createServiceChargeQuote(
    serviceRequestInput: $serviceRequestInput
    quoteInput: $quoteInput
  ) {
    evChargerServiceRequest {
      id
      quotes {
        id
        estimateNumber
        chargerModel
        subtotal
        taxRate
        taxAmount
        taxLabel
        totalCost
      }
    }
    errors {
      ...RegularError
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useCreateServiceChargeQuoteMutation() {
  return Urql.useMutation<CreateServiceChargeQuoteMutation, CreateServiceChargeQuoteMutationVariables>(CreateServiceChargeQuoteDocument);
};
export const CreateSupportTicketDocument = gql`
    mutation CreateSupportTicket($options: CreateSupportTicketInput!) {
  createSupportTicket(options: $options) {
    ticket {
      ...SupportTicket
    }
    errors {
      ...RegularError
    }
  }
}
    ${SupportTicketFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useCreateSupportTicketMutation() {
  return Urql.useMutation<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>(CreateSupportTicketDocument);
};
export const DeleteAccountDocument = gql`
    mutation DeleteAccount {
  deleteAccount
}
    `;

export function useDeleteAccountMutation() {
  return Urql.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument);
};
export const DeleteBookingDocument = gql`
    mutation DeleteBooking($id: Int!) {
  deleteBooking(id: $id)
}
    `;

export function useDeleteBookingMutation() {
  return Urql.useMutation<DeleteBookingMutation, DeleteBookingMutationVariables>(DeleteBookingDocument);
};
export const DeleteEvChargerServiceDocument = gql`
    mutation DeleteEvChargerService($id: Float!) {
  deleteEVChargerService(id: $id) {
    success
    message
  }
}
    `;

export function useDeleteEvChargerServiceMutation() {
  return Urql.useMutation<DeleteEvChargerServiceMutation, DeleteEvChargerServiceMutationVariables>(DeleteEvChargerServiceDocument);
};
export const DeleteQuoteDocument = gql`
    mutation DeleteQuote($id: Float!) {
  deleteQuote(id: $id)
}
    `;

export function useDeleteQuoteMutation() {
  return Urql.useMutation<DeleteQuoteMutation, DeleteQuoteMutationVariables>(DeleteQuoteDocument);
};
export const DeleteSupportTicketDocument = gql`
    mutation DeleteSupportTicket($ticketId: Int!) {
  deleteSupportTicket(ticketId: $ticketId)
}
    `;

export function useDeleteSupportTicketMutation() {
  return Urql.useMutation<DeleteSupportTicketMutation, DeleteSupportTicketMutationVariables>(DeleteSupportTicketDocument);
};
export const DeleteTicketCommentDocument = gql`
    mutation DeleteTicketComment($commentId: Int!) {
  deleteTicketComment(commentId: $commentId)
}
    `;

export function useDeleteTicketCommentMutation() {
  return Urql.useMutation<DeleteTicketCommentMutation, DeleteTicketCommentMutationVariables>(DeleteTicketCommentDocument);
};
export const GoogleLoginDocument = gql`
    mutation GoogleLogin($accessToken: String!) {
  googleLogin(accessToken: $accessToken) {
    account {
      ...Account
    }
    errors {
      ...RegularError
    }
  }
}
    ${AccountFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useGoogleLoginMutation() {
  return Urql.useMutation<GoogleLoginMutation, GoogleLoginMutationVariables>(GoogleLoginDocument);
};
export const LoginDocument = gql`
    mutation Login($options: EmailPasswordInput!) {
  login(options: $options) {
    account {
      ...Account
    }
    errors {
      ...RegularError
    }
  }
}
    ${AccountFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
};
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const MarkConversationReadDocument = gql`
    mutation MarkConversationRead($conversationId: Int!) {
  markConversationRead(conversationId: $conversationId) {
    ...Conversation
  }
}
    ${ConversationFragmentDoc}`;

export function useMarkConversationReadMutation() {
  return Urql.useMutation<MarkConversationReadMutation, MarkConversationReadMutationVariables>(MarkConversationReadDocument);
};
export const MarkTicketReadDocument = gql`
    mutation MarkTicketRead($ticketId: Int!, $asAdmin: Boolean) {
  markTicketRead(ticketId: $ticketId, asAdmin: $asAdmin) {
    ...SupportTicket
  }
}
    ${SupportTicketFragmentDoc}`;

export function useMarkTicketReadMutation() {
  return Urql.useMutation<MarkTicketReadMutation, MarkTicketReadMutationVariables>(MarkTicketReadDocument);
};
export const AcceptVendorAgreementDocument = gql`
    mutation AcceptVendorAgreement {
  acceptVendorAgreement {
    vendor {
      id
      agreementAcceptedAt
    }
    errors {
      ...RegularError
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useAcceptVendorAgreementMutation() {
  return Urql.useMutation<AcceptVendorAgreementMutation, AcceptVendorAgreementMutationVariables>(AcceptVendorAgreementDocument);
};
export const SetOnboardingStepDocument = gql`
    mutation SetOnboardingStep($step: String!) {
  setOnboardingStep(step: $step) {
    vendor {
      id
      onboardingStep
    }
    errors {
      ...RegularError
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useSetOnboardingStepMutation() {
  return Urql.useMutation<SetOnboardingStepMutation, SetOnboardingStepMutationVariables>(SetOnboardingStepDocument);
};
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!) {
  requestPasswordReset(email: $email) {
    success
    errors {
      ...RegularError
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useRequestPasswordResetMutation() {
  return Urql.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument);
};
export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!, $code: String!, $password: String!) {
  resetPassword(email: $email, code: $code, password: $password) {
    success
    errors {
      ...RegularError
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useResetPasswordMutation() {
  return Urql.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument);
};
export const RegisterAccountDocument = gql`
    mutation RegisterAccount($options: RegisterInput!) {
  registerAccount(options: $options) {
    account {
      ...Account
    }
    errors {
      ...RegularError
    }
  }
}
    ${AccountFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useRegisterAccountMutation() {
  return Urql.useMutation<RegisterAccountMutation, RegisterAccountMutationVariables>(RegisterAccountDocument);
};
export const RegisterAccountWithVendorDocument = gql`
    mutation RegisterAccountWithVendor($accountInput: RegisterInput!, $vendorInput: VendorInput!) {
  registerAccountWithVendor(
    accountInput: $accountInput
    vendorInput: $vendorInput
  ) {
    account {
      ...Account
    }
    errors {
      ...RegularError
    }
  }
}
    ${AccountFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useRegisterAccountWithVendorMutation() {
  return Urql.useMutation<RegisterAccountWithVendorMutation, RegisterAccountWithVendorMutationVariables>(RegisterAccountWithVendorDocument);
};
export const RenewQuoteDocument = gql`
    mutation RenewQuote($id: Float!) {
  renewQuote(id: $id) {
    id
    expiresAt
    isExpired
  }
}
    `;

export function useRenewQuoteMutation() {
  return Urql.useMutation<RenewQuoteMutation, RenewQuoteMutationVariables>(RenewQuoteDocument);
};
export const RequestBookingDocument = gql`
    mutation RequestBooking($input: RequestBookingInput!) {
  requestBooking(input: $input) {
    booking {
      ...Booking
    }
    errors {
      ...RegularError
    }
  }
}
    ${BookingFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useRequestBookingMutation() {
  return Urql.useMutation<RequestBookingMutation, RequestBookingMutationVariables>(RequestBookingDocument);
};
export const ResendClientLinkDocument = gql`
    mutation ResendClientLink($quoteId: Int!) {
  resendClientLink(quoteId: $quoteId) {
    sent
    errors {
      ...RegularError
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useResendClientLinkMutation() {
  return Urql.useMutation<ResendClientLinkMutation, ResendClientLinkMutationVariables>(ResendClientLinkDocument);
};
export const RespondToBookingDocument = gql`
    mutation RespondToBooking($bookingId: Int!, $response: String!, $proposedDate: String, $proposedFrom: String, $proposedTo: String) {
  respondToBooking(
    bookingId: $bookingId
    response: $response
    proposedDate: $proposedDate
    proposedFrom: $proposedFrom
    proposedTo: $proposedTo
  ) {
    booking {
      ...Booking
    }
    errors {
      ...RegularError
    }
  }
}
    ${BookingFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useRespondToBookingMutation() {
  return Urql.useMutation<RespondToBookingMutation, RespondToBookingMutationVariables>(RespondToBookingDocument);
};
export const RespondToQuoteDocument = gql`
    mutation RespondToQuote($id: Int!, $response: String!, $note: String) {
  respondToQuote(id: $id, response: $response, note: $note) {
    errors {
      ...RegularError
    }
    quote {
      id
      approvalStatus
      approvalRespondedAt
      changeRequestNote
      userAccepted
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useRespondToQuoteMutation() {
  return Urql.useMutation<RespondToQuoteMutation, RespondToQuoteMutationVariables>(RespondToQuoteDocument);
};
export const ResubmitVendorApplicationDocument = gql`
    mutation ResubmitVendorApplication {
  resubmitVendorApplication {
    vendor {
      id
      verificationStatus
      rejectionReason
    }
    errors {
      ...RegularError
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useResubmitVendorApplicationMutation() {
  return Urql.useMutation<ResubmitVendorApplicationMutation, ResubmitVendorApplicationMutationVariables>(ResubmitVendorApplicationDocument);
};
export const ReviseQuoteDocument = gql`
    mutation ReviseQuote($id: Int!, $input: ReviseQuoteInput!) {
  reviseQuote(id: $id, input: $input) {
    errors {
      ...RegularError
    }
    quote {
      id
      stage
      approvalStatus
      approvalRespondedAt
      changeRequestNote
      userAccepted
      chargerModel
      chargerCost
      addOns {
        label
        price
      }
      installationCost
      subtotal
      taxRate
      taxAmount
      taxLabel
      totalCost
      inclusions
      assumptions
      notes
      paymentTerms
      expiresAt
      isExpired
      updatedAt
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useReviseQuoteMutation() {
  return Urql.useMutation<ReviseQuoteMutation, ReviseQuoteMutationVariables>(ReviseQuoteDocument);
};
export const SendEmailVerificationDocument = gql`
    mutation SendEmailVerification($email: String!) {
  sendEmailVerification(email: $email) {
    success
    errors {
      field
      message
    }
  }
}
    `;

export function useSendEmailVerificationMutation() {
  return Urql.useMutation<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>(SendEmailVerificationDocument);
};
export const SendMessageDocument = gql`
    mutation SendMessage($options: SendMessageInput!) {
  sendMessage(options: $options) {
    message {
      ...Message
    }
    errors {
      ...RegularError
    }
  }
}
    ${MessageFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useSendMessageMutation() {
  return Urql.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument);
};
export const SetConversationArchivedDocument = gql`
    mutation SetConversationArchived($conversationId: Int!, $archived: Boolean!) {
  setConversationArchived(conversationId: $conversationId, archived: $archived) {
    ...Conversation
  }
}
    ${ConversationFragmentDoc}`;

export function useSetConversationArchivedMutation() {
  return Urql.useMutation<SetConversationArchivedMutation, SetConversationArchivedMutationVariables>(SetConversationArchivedDocument);
};
export const SetConversationStarredDocument = gql`
    mutation SetConversationStarred($conversationId: Int!, $starred: Boolean!) {
  setConversationStarred(conversationId: $conversationId, starred: $starred) {
    ...Conversation
  }
}
    ${ConversationFragmentDoc}`;

export function useSetConversationStarredMutation() {
  return Urql.useMutation<SetConversationStarredMutation, SetConversationStarredMutationVariables>(SetConversationStarredDocument);
};
export const SetPreferredLanguageDocument = gql`
    mutation SetPreferredLanguage($language: String!) {
  setPreferredLanguage(language: $language) {
    account {
      id
      preferredLanguage
    }
    errors {
      ...RegularError
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useSetPreferredLanguageMutation() {
  return Urql.useMutation<SetPreferredLanguageMutation, SetPreferredLanguageMutationVariables>(SetPreferredLanguageDocument);
};
export const SetTicketStatusDocument = gql`
    mutation SetTicketStatus($ticketId: Int!, $status: TicketStatus!, $asAdmin: Boolean) {
  setTicketStatus(ticketId: $ticketId, status: $status, asAdmin: $asAdmin) {
    ticket {
      ...SupportTicket
    }
    errors {
      ...RegularError
    }
  }
}
    ${SupportTicketFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useSetTicketStatusMutation() {
  return Urql.useMutation<SetTicketStatusMutation, SetTicketStatusMutationVariables>(SetTicketStatusDocument);
};
export const SetVendorAvailabilityDocument = gql`
    mutation SetVendorAvailability($input: SetVendorAvailabilityInput!) {
  setVendorAvailability(input: $input) {
    availability {
      ...VendorAvailability
    }
    errors {
      ...RegularError
    }
  }
}
    ${VendorAvailabilityFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useSetVendorAvailabilityMutation() {
  return Urql.useMutation<SetVendorAvailabilityMutation, SetVendorAvailabilityMutationVariables>(SetVendorAvailabilityDocument);
};
export const StartConversationDocument = gql`
    mutation StartConversation($otherPartyId: Int!) {
  startConversation(otherPartyId: $otherPartyId) {
    conversation {
      ...Conversation
    }
    errors {
      ...RegularError
    }
  }
}
    ${ConversationFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useStartConversationMutation() {
  return Urql.useMutation<StartConversationMutation, StartConversationMutationVariables>(StartConversationDocument);
};
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($options: UpdateAccountInput!) {
  updateAccount(options: $options) {
    account {
      ...Account
    }
    errors {
      ...RegularError
    }
  }
}
    ${AccountFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useUpdateAccountMutation() {
  return Urql.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument);
};
export const UpdateBookingDocument = gql`
    mutation UpdateBooking($id: Int!, $input: BookingInput!) {
  updateBooking(id: $id, input: $input) {
    booking {
      ...Booking
    }
    errors {
      ...RegularError
    }
  }
}
    ${BookingFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useUpdateBookingMutation() {
  return Urql.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(UpdateBookingDocument);
};
export const UpdateEvChargerServiceDocument = gql`
    mutation UpdateEVChargerService($id: Float!, $options: EVChargerServiceInput!) {
  updateEVChargerService(id: $id, options: $options) {
    errors {
      ...RegularError
    }
    evChargerService {
      id
      areaServiced
      quoteValidFor
      paymentTerms
      updatedAt
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useUpdateEvChargerServiceMutation() {
  return Urql.useMutation<UpdateEvChargerServiceMutation, UpdateEvChargerServiceMutationVariables>(UpdateEvChargerServiceDocument);
};
export const UpdateMyQuoteDocument = gql`
    mutation UpdateMyQuote($id: Float!, $starred: Boolean, $archived: Boolean, $viewed: Boolean) {
  updateMyQuote(id: $id, starred: $starred, archived: $archived, viewed: $viewed) {
    id
    starred
    archived
    viewed
  }
}
    `;

export function useUpdateMyQuoteMutation() {
  return Urql.useMutation<UpdateMyQuoteMutation, UpdateMyQuoteMutationVariables>(UpdateMyQuoteDocument);
};
export const UpdatePrivatePortalDocument = gql`
    mutation UpdatePrivatePortal($slug: String, $enabled: Boolean, $serviceId: Int, $language: String) {
  updatePrivatePortal(
    slug: $slug
    enabled: $enabled
    serviceId: $serviceId
    language: $language
  ) {
    portalUrl
    vendor {
      id
      slug
      privatePortalEnabled
      portalLanguage
      privatePortalService {
        id
      }
    }
    errors {
      ...RegularError
    }
  }
}
    ${RegularErrorFragmentDoc}`;

export function useUpdatePrivatePortalMutation() {
  return Urql.useMutation<UpdatePrivatePortalMutation, UpdatePrivatePortalMutationVariables>(UpdatePrivatePortalDocument);
};
export const UpdateQuoteDocument = gql`
    mutation UpdateQuote($id: Float!, $stage: String, $assignedTo: String, $starred: Boolean, $archived: Boolean, $viewed: Boolean) {
  updateQuote(
    id: $id
    stage: $stage
    assignedTo: $assignedTo
    starred: $starred
    archived: $archived
    viewed: $viewed
  ) {
    id
    stage
    assignedTo
    starred
    archived
    viewed
  }
}
    `;

export function useUpdateQuoteMutation() {
  return Urql.useMutation<UpdateQuoteMutation, UpdateQuoteMutationVariables>(UpdateQuoteDocument);
};
export const UpdateVendorDocument = gql`
    mutation UpdateVendor($options: UpdateVendorInput!) {
  updateVendor(options: $options) {
    vendor {
      ...Vendor
    }
    errors {
      ...RegularError
    }
    warnings {
      ...RegularError
    }
  }
}
    ${VendorFragmentDoc}
${RegularErrorFragmentDoc}`;

export function useUpdateVendorMutation() {
  return Urql.useMutation<UpdateVendorMutation, UpdateVendorMutationVariables>(UpdateVendorDocument);
};
export const UploadFileDocument = gql`
    mutation UploadFile($options: FileUploadInput!) {
  uploadFile(options: $options) {
    ...FileUpload
  }
}
    ${FileUploadFragmentDoc}`;

export function useUploadFileMutation() {
  return Urql.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument);
};
export const VerifyEmailCodeDocument = gql`
    mutation VerifyEmailCode($email: String!, $code: String!) {
  verifyEmailCode(email: $email, code: $code) {
    success
    errors {
      field
      message
    }
  }
}
    `;

export function useVerifyEmailCodeMutation() {
  return Urql.useMutation<VerifyEmailCodeMutation, VerifyEmailCodeMutationVariables>(VerifyEmailCodeDocument);
};
export const MeDocument = gql`
    query Me {
  me {
    ...Account
  }
}
    ${AccountFragmentDoc}`;

export function useMeQuery(options?: Omit<Urql.UseQueryArgs<MeQueryVariables>, 'query'>) {
  return Urql.useQuery<MeQuery, MeQueryVariables>({ query: MeDocument, ...options });
};
export const AdminExpiringVendorsDocument = gql`
    query AdminExpiringVendors {
  adminExpiringVendors {
    ...AdminVendor
  }
}
    ${AdminVendorFragmentDoc}`;

export function useAdminExpiringVendorsQuery(options?: Omit<Urql.UseQueryArgs<AdminExpiringVendorsQueryVariables>, 'query'>) {
  return Urql.useQuery<AdminExpiringVendorsQuery, AdminExpiringVendorsQueryVariables>({ query: AdminExpiringVendorsDocument, ...options });
};
export const AdminSummaryDocument = gql`
    query AdminSummary {
  adminSummary {
    pendingGoogleReviews
    unverifiedVendors
    openTickets
  }
}
    `;

export function useAdminSummaryQuery(options?: Omit<Urql.UseQueryArgs<AdminSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<AdminSummaryQuery, AdminSummaryQueryVariables>({ query: AdminSummaryDocument, ...options });
};
export const AdminUsersDocument = gql`
    query AdminUsers($search: String, $suspendedOnly: Boolean, $offset: Int, $limit: Int) {
  adminUsers(
    search: $search
    suspendedOnly: $suspendedOnly
    offset: $offset
    limit: $limit
  ) {
    total
    items {
      ...AdminUser
    }
  }
}
    ${AdminUserFragmentDoc}`;

export function useAdminUsersQuery(options?: Omit<Urql.UseQueryArgs<AdminUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<AdminUsersQuery, AdminUsersQueryVariables>({ query: AdminUsersDocument, ...options });
};
export const AdminVendorsDocument = gql`
    query AdminVendors($search: String, $filter: AdminVendorFilter, $offset: Int, $limit: Int) {
  adminVendors(search: $search, filter: $filter, offset: $offset, limit: $limit) {
    total
    items {
      ...AdminVendor
    }
  }
}
    ${AdminVendorFragmentDoc}`;

export function useAdminVendorsQuery(options?: Omit<Urql.UseQueryArgs<AdminVendorsQueryVariables>, 'query'>) {
  return Urql.useQuery<AdminVendorsQuery, AdminVendorsQueryVariables>({ query: AdminVendorsDocument, ...options });
};
export const AnalyticsOverviewDocument = gql`
    query AnalyticsOverview($days: Int!, $site: String) {
  analyticsOverview(days: $days, site: $site) {
    uniqueVisitors
    pageviews
    signups
    estimatorStarts
    estimatorSubmissions
    errors
  }
}
    `;

export function useAnalyticsOverviewQuery(options: Omit<Urql.UseQueryArgs<AnalyticsOverviewQueryVariables>, 'query'>) {
  return Urql.useQuery<AnalyticsOverviewQuery, AnalyticsOverviewQueryVariables>({ query: AnalyticsOverviewDocument, ...options });
};
export const AnalyticsTimeseriesDocument = gql`
    query AnalyticsTimeseries($days: Int!, $site: String) {
  analyticsTimeseries(days: $days, site: $site) {
    date
    visitors
    pageviews
  }
}
    `;

export function useAnalyticsTimeseriesQuery(options: Omit<Urql.UseQueryArgs<AnalyticsTimeseriesQueryVariables>, 'query'>) {
  return Urql.useQuery<AnalyticsTimeseriesQuery, AnalyticsTimeseriesQueryVariables>({ query: AnalyticsTimeseriesDocument, ...options });
};
export const AnalyticsBreakdownsDocument = gql`
    query AnalyticsBreakdowns($days: Int!, $site: String) {
  analyticsBreakdowns(days: $days, site: $site) {
    countries {
      ...AnalyticsBreakdownRow
    }
    regions {
      ...AnalyticsBreakdownRow
    }
    cities {
      ...AnalyticsBreakdownRow
    }
    pages {
      ...AnalyticsBreakdownRow
    }
    devices {
      ...AnalyticsBreakdownRow
    }
    browsers {
      ...AnalyticsBreakdownRow
    }
    referrers {
      ...AnalyticsBreakdownRow
    }
  }
}
    ${AnalyticsBreakdownRowFragmentDoc}`;

export function useAnalyticsBreakdownsQuery(options: Omit<Urql.UseQueryArgs<AnalyticsBreakdownsQueryVariables>, 'query'>) {
  return Urql.useQuery<AnalyticsBreakdownsQuery, AnalyticsBreakdownsQueryVariables>({ query: AnalyticsBreakdownsDocument, ...options });
};
export const AnalyticsFunnelDocument = gql`
    query AnalyticsFunnel($days: Int!) {
  analyticsFunnel(days: $days) {
    step
    index
    visitors
  }
}
    `;

export function useAnalyticsFunnelQuery(options: Omit<Urql.UseQueryArgs<AnalyticsFunnelQueryVariables>, 'query'>) {
  return Urql.useQuery<AnalyticsFunnelQuery, AnalyticsFunnelQueryVariables>({ query: AnalyticsFunnelDocument, ...options });
};
export const MarketplaceHealthDocument = gql`
    query MarketplaceHealth($days: Int!) {
  marketplaceHealth(days: $days) {
    newUsers
    newVendors
    serviceRequests
    quotesSent
    quotesApproved
    bookings
  }
}
    `;

export function useMarketplaceHealthQuery(options: Omit<Urql.UseQueryArgs<MarketplaceHealthQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceHealthQuery, MarketplaceHealthQueryVariables>({ query: MarketplaceHealthDocument, ...options });
};
export const GetVendorAvailabilityDocument = gql`
    query GetVendorAvailability {
  vendorAvailability {
    ...VendorAvailability
  }
}
    ${VendorAvailabilityFragmentDoc}`;

export function useGetVendorAvailabilityQuery(options?: Omit<Urql.UseQueryArgs<GetVendorAvailabilityQueryVariables>, 'query'>) {
  return Urql.useQuery<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables>({ query: GetVendorAvailabilityDocument, ...options });
};
export const VendorAvailabilityForQuoteDocument = gql`
    query VendorAvailabilityForQuote($quoteId: Int!) {
  vendorAvailabilityForQuote(quoteId: $quoteId) {
    availabilityConfigured
    availability {
      ...VendorAvailability
    }
    busySlots {
      date
      fromTime
      toTime
      allDay
    }
  }
}
    ${VendorAvailabilityFragmentDoc}`;

export function useVendorAvailabilityForQuoteQuery(options: Omit<Urql.UseQueryArgs<VendorAvailabilityForQuoteQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAvailabilityForQuoteQuery, VendorAvailabilityForQuoteQueryVariables>({ query: VendorAvailabilityForQuoteDocument, ...options });
};
export const MyInvitedBookingsDocument = gql`
    query MyInvitedBookings {
  myInvitedBookings {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useMyInvitedBookingsQuery(options?: Omit<Urql.UseQueryArgs<MyInvitedBookingsQueryVariables>, 'query'>) {
  return Urql.useQuery<MyInvitedBookingsQuery, MyInvitedBookingsQueryVariables>({ query: MyInvitedBookingsDocument, ...options });
};
export const VendorBookingsDocument = gql`
    query VendorBookings {
  vendorBookings {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useVendorBookingsQuery(options?: Omit<Urql.UseQueryArgs<VendorBookingsQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorBookingsQuery, VendorBookingsQueryVariables>({ query: VendorBookingsDocument, ...options });
};
export const EvListDocument = gql`
    query EVList {
  getEVList {
    id
    modelYear
    make
    model
    vehicleClass
    motor
    transmission
    fuelType
    cityEnergyConsumption
    highwayEnergyConsumption
    combinedEnergyConsumption
    cityFuelConsumptionLe
    highwayFuelConsumptionLe
    combinedFuelConsumptionLe
    range
    co2Emissions
    co2Rating
    smogRating
    rechargeTime
  }
}
    `;

export function useEvListQuery(options?: Omit<Urql.UseQueryArgs<EvListQueryVariables>, 'query'>) {
  return Urql.useQuery<EvListQuery, EvListQueryVariables>({ query: EvListDocument, ...options });
};
export const GetEvChargerServiceListDocument = gql`
    query GetEVChargerServiceList($vehicleType: String, $houseType: String, $evseType: String, $wireLength: String) {
  getEVChargerServiceList(
    vehicleType: $vehicleType
    houseType: $houseType
    evseType: $evseType
    wireLength: $wireLength
  ) {
    id
    areaServiced
    quoteValidFor
    paymentTerms
    evChargerServiceFields {
      id
      fieldLabel
      customLabel
      price
      isChecked
      duplicates
      placeholder
      fieldType
      fieldName
      createdAt
      updatedAt
    }
    vendor {
      id
      businessName
    }
    createdAt
    updatedAt
  }
}
    `;

export function useGetEvChargerServiceListQuery(options?: Omit<Urql.UseQueryArgs<GetEvChargerServiceListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEvChargerServiceListQuery, GetEvChargerServiceListQueryVariables>({ query: GetEvChargerServiceListDocument, ...options });
};
export const GetEvChargerServiceListByVendorDocument = gql`
    query GetEVChargerServiceListByVendor($vendorId: Float!) {
  getEVChargerServiceListByVendor(vendorId: $vendorId) {
    id
    areaServiced
    quoteValidFor
    paymentTerms
    evChargerServiceFields {
      id
      fieldLabel
      customLabel
      price
      isChecked
      duplicates
      placeholder
      fieldType
      fieldName
      createdAt
      updatedAt
    }
    vendor {
      id
      businessName
    }
    createdAt
    updatedAt
  }
}
    `;

export function useGetEvChargerServiceListByVendorQuery(options: Omit<Urql.UseQueryArgs<GetEvChargerServiceListByVendorQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEvChargerServiceListByVendorQuery, GetEvChargerServiceListByVendorQueryVariables>({ query: GetEvChargerServiceListByVendorDocument, ...options });
};
export const GetEvChargerServiceRecommendationsDocument = gql`
    query GetEVChargerServiceRecommendations($vehicleType: String, $houseType: String, $evseType: String, $wireLength: String, $sortBy: EVChargerServiceSortBy, $limit: Float, $userLat: Float, $userLng: Float) {
  getEVChargerServiceRecommendations(
    vehicleType: $vehicleType
    houseType: $houseType
    evseType: $evseType
    wireLength: $wireLength
    sortBy: $sortBy
    limit: $limit
    userLat: $userLat
    userLng: $userLng
  ) {
    id
    areaServiced
    quoteValidFor
    paymentTerms
    distanceKm
    evChargerServiceFields {
      id
      fieldLabel
      customLabel
      price
      isChecked
      duplicates
      placeholder
      fieldType
      fieldName
      createdAt
      updatedAt
    }
    vendor {
      id
      businessName: displayName
      address
      latitude
      longitude
      publicEmail
      publicPhone
      businessWebsite
      businessNumber
      brandLogoURL
      brandAbout
      isVerified
      googleListing {
        ...GoogleListing
      }
    }
    createdAt
    updatedAt
  }
}
    ${GoogleListingFragmentDoc}`;

export function useGetEvChargerServiceRecommendationsQuery(options?: Omit<Urql.UseQueryArgs<GetEvChargerServiceRecommendationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEvChargerServiceRecommendationsQuery, GetEvChargerServiceRecommendationsQueryVariables>({ query: GetEvChargerServiceRecommendationsDocument, ...options });
};
export const GetLeadsByVendorDocument = gql`
    query GetLeadsByVendor {
  getLeadsByVendor {
    id
    distance
    stage
    assignedTo
    starred
    archived
    viewed
    createdAt
    expiresAt
    isExpired
    estimateNumber
    userAccepted
    approvalStatus
    approvalRespondedAt
    changeRequestNote
    chargerModel
    chargerCost
    addOns {
      label
      price
    }
    installationCost
    subtotal
    taxRate
    taxAmount
    taxLabel
    totalCost
    inclusions
    assumptions
    notes
    paymentTerms
    evChargerService {
      id
      quoteValidFor
      vendor {
        id
        businessName
        address
        phoneNumber
        businessWebsite
        brandLogoURL
        brandAbout
        googleListing {
          ...GoogleListing
        }
      }
    }
    chargerServiceRequest {
      id
      address
      createdAt
      installationType
      vehicleType
      houseType
      chargerLocation
      chargerSetup
      electricalPanelLocation
      mainServiceSize
      electricalPanelPhotoURL
      mainBreakerPhotoURL
      wireLength
      purchaseType
      elevator
      pool
      hotTub
      additionalInformation
      account {
        id
        firstName
        lastName
        email
        phoneNumber
        invitedByVendor {
          id
        }
      }
    }
  }
}
    ${GoogleListingFragmentDoc}`;

export function useGetLeadsByVendorQuery(options?: Omit<Urql.UseQueryArgs<GetLeadsByVendorQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLeadsByVendorQuery, GetLeadsByVendorQueryVariables>({ query: GetLeadsByVendorDocument, ...options });
};
export const GetQuotesByAccountDocument = gql`
    query GetQuotesByAccount {
  getQuotesByAccount {
    id
    estimateNumber
    userAccepted
    approvalStatus
    starred
    archived
    viewed
    approvalRespondedAt
    changeRequestNote
    distance
    chargerModel
    chargerCost
    addOns {
      label
      price
    }
    installationCost
    subtotal
    taxRate
    taxAmount
    taxLabel
    totalCost
    inclusions
    assumptions
    notes
    paymentTerms
    expiresAt
    isExpired
    createdAt
    updatedAt
    evChargerService {
      id
      quoteValidFor
      vendor {
        id
        businessName: displayName
        address
        publicEmail
        publicPhone
        businessWebsite
        businessNumber
        brandLogoURL
        brandAbout
        isVerified
        googleListing {
          ...GoogleListing
        }
      }
    }
    chargerServiceRequest {
      id
      address
      installationType
      vehicleType
      houseType
      chargerLocation
      chargerSetup
      electricalPanelLocation
      mainServiceSize
      electricalPanelPhotoURL
      mainBreakerPhotoURL
      wireLength
      purchaseType
      elevator
      pool
      hotTub
      additionalInformation
    }
  }
}
    ${GoogleListingFragmentDoc}`;

export function useGetQuotesByAccountQuery(options?: Omit<Urql.UseQueryArgs<GetQuotesByAccountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetQuotesByAccountQuery, GetQuotesByAccountQueryVariables>({ query: GetQuotesByAccountDocument, ...options });
};
export const IceListDocument = gql`
    query ICEList {
  getICEList {
    id
    modelYear
    make
    model
    vehicleClass
    engineSize
    cylinders
    transmission
    fuelType
    cityFuelConsumption
    highwayFuelConsumption
    combinedFuelConsumption
    combinedMPG
    co2Emissions
    co2Rating
    smogRating
  }
}
    `;

export function useIceListQuery(options?: Omit<Urql.UseQueryArgs<IceListQueryVariables>, 'query'>) {
  return Urql.useQuery<IceListQuery, IceListQueryVariables>({ query: IceListDocument, ...options });
};
export const GetIceVehicleDocument = gql`
    query GetICEVehicle($iceVehicleId: Float!) {
  getICEVehicle(id: $iceVehicleId) {
    id
    modelYear
    make
    model
    vehicleClass
    engineSize
    cylinders
    transmission
    fuelType
    cityFuelConsumption
    highwayFuelConsumption
    combinedFuelConsumption
    combinedMPG
    co2Emissions
    co2Rating
    smogRating
  }
}
    `;

export function useGetIceVehicleQuery(options: Omit<Urql.UseQueryArgs<GetIceVehicleQueryVariables>, 'query'>) {
  return Urql.useQuery<GetIceVehicleQuery, GetIceVehicleQueryVariables>({ query: GetIceVehicleDocument, ...options });
};
export const GetConversationsDocument = gql`
    query GetConversations {
  getConversations {
    ...Conversation
  }
}
    ${ConversationFragmentDoc}`;

export function useGetConversationsQuery(options?: Omit<Urql.UseQueryArgs<GetConversationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetConversationsQuery, GetConversationsQueryVariables>({ query: GetConversationsDocument, ...options });
};
export const GetMessageableCounterpartsDocument = gql`
    query GetMessageableCounterparts {
  getMessageableCounterparts {
    otherPartyId
    name
    avatarUrl
    conversationId
  }
}
    `;

export function useGetMessageableCounterpartsQuery(options?: Omit<Urql.UseQueryArgs<GetMessageableCounterpartsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMessageableCounterpartsQuery, GetMessageableCounterpartsQueryVariables>({ query: GetMessageableCounterpartsDocument, ...options });
};
export const GetMessagesDocument = gql`
    query GetMessages($conversationId: Int!, $beforeId: Int, $limit: Int) {
  getMessages(conversationId: $conversationId, beforeId: $beforeId, limit: $limit) {
    messages {
      ...Message
    }
    hasMore
  }
}
    ${MessageFragmentDoc}`;

export function useGetMessagesQuery(options: Omit<Urql.UseQueryArgs<GetMessagesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMessagesQuery, GetMessagesQueryVariables>({ query: GetMessagesDocument, ...options });
};
export const PhevListDocument = gql`
    query PHEVList {
  getPHEVList {
    id
    modelYear
    make
    model
    vehicleClass
    motor
    engineSize
    cylinders
    transmission
    fuelType1
    fuelType2
    combinedLe
    range1
    range2
    rechargeTime
    cityFuelConsumption
    highwayFuelConsumption
    combinedFuelConsumption
    co2Emissions
    co2Rating
    smogRating
  }
}
    `;

export function usePhevListQuery(options?: Omit<Urql.UseQueryArgs<PhevListQueryVariables>, 'query'>) {
  return Urql.useQuery<PhevListQuery, PhevListQueryVariables>({ query: PhevListDocument, ...options });
};
export const AdminTicketsDocument = gql`
    query AdminTickets($status: TicketStatus) {
  adminTickets(status: $status) {
    ...SupportTicket
  }
}
    ${SupportTicketFragmentDoc}`;

export function useAdminTicketsQuery(options?: Omit<Urql.UseQueryArgs<AdminTicketsQueryVariables>, 'query'>) {
  return Urql.useQuery<AdminTicketsQuery, AdminTicketsQueryVariables>({ query: AdminTicketsDocument, ...options });
};
export const MyTicketsDocument = gql`
    query MyTickets {
  myTickets {
    ...SupportTicket
  }
}
    ${SupportTicketFragmentDoc}`;

export function useMyTicketsQuery(options?: Omit<Urql.UseQueryArgs<MyTicketsQueryVariables>, 'query'>) {
  return Urql.useQuery<MyTicketsQuery, MyTicketsQueryVariables>({ query: MyTicketsDocument, ...options });
};
export const SupportTicketDocument = gql`
    query SupportTicket($id: Int!, $asAdmin: Boolean) {
  supportTicket(id: $id, asAdmin: $asAdmin) {
    ...SupportTicket
  }
}
    ${SupportTicketFragmentDoc}`;

export function useSupportTicketQuery(options: Omit<Urql.UseQueryArgs<SupportTicketQueryVariables>, 'query'>) {
  return Urql.useQuery<SupportTicketQuery, SupportTicketQueryVariables>({ query: SupportTicketDocument, ...options });
};
export const SupportUnreadCountDocument = gql`
    query SupportUnreadCount($asAdmin: Boolean) {
  supportUnreadCount(asAdmin: $asAdmin)
}
    `;

export function useSupportUnreadCountQuery(options?: Omit<Urql.UseQueryArgs<SupportUnreadCountQueryVariables>, 'query'>) {
  return Urql.useQuery<SupportUnreadCountQuery, SupportUnreadCountQueryVariables>({ query: SupportUnreadCountDocument, ...options });
};
export const TicketCommentsDocument = gql`
    query TicketComments($ticketId: Int!, $asAdmin: Boolean) {
  ticketComments(ticketId: $ticketId, asAdmin: $asAdmin) {
    ...TicketComment
  }
}
    ${TicketCommentFragmentDoc}`;

export function useTicketCommentsQuery(options: Omit<Urql.UseQueryArgs<TicketCommentsQueryVariables>, 'query'>) {
  return Urql.useQuery<TicketCommentsQuery, TicketCommentsQueryVariables>({ query: TicketCommentsDocument, ...options });
};
export const VendorGoogleListingDocument = gql`
    query VendorGoogleListing($id: Float!) {
  vendor(id: $id) {
    id
    googlePlaceId
    googleListingStatus
    googleListing {
      ...GoogleListing
    }
  }
}
    ${GoogleListingFragmentDoc}`;

export function useVendorGoogleListingQuery(options: Omit<Urql.UseQueryArgs<VendorGoogleListingQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorGoogleListingQuery, VendorGoogleListingQueryVariables>({ query: VendorGoogleListingDocument, ...options });
};
export const MessageSentDocument = gql`
    subscription MessageSent {
  messageSent {
    ...Message
  }
}
    ${MessageFragmentDoc}`;

export function useMessageSentSubscription<TData = MessageSentSubscription>(options?: Omit<Urql.UseSubscriptionArgs<MessageSentSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<MessageSentSubscription, TData>) {
  return Urql.useSubscription<MessageSentSubscription, TData, MessageSentSubscriptionVariables>({ query: MessageSentDocument, ...options }, handler);
};
export const QuoteCreatedDocument = gql`
    subscription QuoteCreated {
  quoteCreated {
    quoteId
  }
}
    `;

export function useQuoteCreatedSubscription<TData = QuoteCreatedSubscription>(options?: Omit<Urql.UseSubscriptionArgs<QuoteCreatedSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<QuoteCreatedSubscription, TData>) {
  return Urql.useSubscription<QuoteCreatedSubscription, TData, QuoteCreatedSubscriptionVariables>({ query: QuoteCreatedDocument, ...options }, handler);
};
export const QuoteUpdatedDocument = gql`
    subscription QuoteUpdated {
  quoteUpdated {
    quoteId
  }
}
    `;

export function useQuoteUpdatedSubscription<TData = QuoteUpdatedSubscription>(options?: Omit<Urql.UseSubscriptionArgs<QuoteUpdatedSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<QuoteUpdatedSubscription, TData>) {
  return Urql.useSubscription<QuoteUpdatedSubscription, TData, QuoteUpdatedSubscriptionVariables>({ query: QuoteUpdatedDocument, ...options }, handler);
};
export const SupportTicketChangedDocument = gql`
    subscription SupportTicketChanged {
  supportTicketChanged
}
    `;

export function useSupportTicketChangedSubscription<TData = SupportTicketChangedSubscription>(options?: Omit<Urql.UseSubscriptionArgs<SupportTicketChangedSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<SupportTicketChangedSubscription, TData>) {
  return Urql.useSubscription<SupportTicketChangedSubscription, TData, SupportTicketChangedSubscriptionVariables>({ query: SupportTicketChangedDocument, ...options }, handler);
};